const ArabicTokens = {
    "name": "arabic",
    "selectors": [":lang(ar)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AnovaUI', 'Geeza Pro', 'Helvetica Neue', 'Helvetica', 'Arial,' sans-serif",
        "font-family-secondary": "'Anova', 'Geeza Pro', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "24px",
        "font-size-line-height-body-text-m": "21px",
        "font-size-line-height-body-text-s": "18px",
        "font-size-line-height-body-text-xl": "27px",
        "font-size-line-height-body-text-xs": "16.5px",
        "font-size-line-height-body-text-xxl": "30px",
        "font-size-line-height-body-text-xxs": "15px",
        "font-size-line-height-body-text-xxxl": "33px",
        "font-size-line-height-body-text-xxxs": "13.5px",
        "font-size-line-height-body-text-xxxxl": "37.5px",
        "font-size-line-height-display-text-1": "109.5px",
        "font-size-line-height-display-text-2": "87px",
        "font-size-line-height-display-text-3": "60px",
        "font-size-line-height-heading-text-l": "24px",
        "font-size-line-height-heading-text-m": "21px",
        "font-size-line-height-heading-text-s": "18px",
        "font-size-line-height-heading-text-xl": "27px",
        "font-size-line-height-heading-text-xxl": "30px",
        "font-size-line-height-heading-text-xxxl": "33px",
        "font-size-line-height-heading-text-xxxxl": "42px",
        "font-size-line-height-heading-text-xxxxxl": "87px",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "3rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4rem"
    }
};

const ArabicPseudoTokens = {
    "name": "arabicPseudo",
    "selectors": [":lang(ar-xx)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AnovaUI', 'PseudoArabic', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'Anova', 'PseudoArabic', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "24px",
        "font-size-line-height-body-text-m": "21px",
        "font-size-line-height-body-text-s": "18px",
        "font-size-line-height-body-text-xl": "27px",
        "font-size-line-height-body-text-xs": "16.5px",
        "font-size-line-height-body-text-xxl": "30px",
        "font-size-line-height-body-text-xxs": "15px",
        "font-size-line-height-body-text-xxxl": "33px",
        "font-size-line-height-body-text-xxxs": "13.5px",
        "font-size-line-height-body-text-xxxxl": "37.5px",
        "font-size-line-height-display-text-1": "109.5px",
        "font-size-line-height-display-text-2": "87px",
        "font-size-line-height-display-text-3": "60px",
        "font-size-line-height-heading-text-l": "24px",
        "font-size-line-height-heading-text-m": "21px",
        "font-size-line-height-heading-text-s": "18px",
        "font-size-line-height-heading-text-xl": "27px",
        "font-size-line-height-heading-text-xxl": "30px",
        "font-size-line-height-heading-text-xxxl": "33px",
        "font-size-line-height-heading-text-xxxxl": "42px",
        "font-size-line-height-heading-text-xxxxxl": "87px",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "3rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4rem"
    }
};

const ChineseChinaTokens = {
    "name": "chineseChina",
    "selectors": [":lang(zh)", ":lang(zh-cn)", ":lang(zh-sg)", ":lang(zh-hans)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AnovaUI', '微软雅黑体', 'Microsoft YaHei New', '微软雅黑', 'Microsoft Yahei', '宋体', 'SimSun', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'Anova', '微软雅黑体', 'Microsoft YaHei New', '微软雅黑', 'Microsoft Yahei', '宋体', 'SimSun', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.8125rem",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125rem",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "3.25rem",
        "font-size-heading-text-xxxxxxl": "4.125rem",
        "font-size-line-height-body-text-l": "27px",
        "font-size-line-height-body-text-m": "24px",
        "font-size-line-height-body-text-s": "21px",
        "font-size-line-height-body-text-xl": "30px",
        "font-size-line-height-body-text-xs": "19.5px",
        "font-size-line-height-body-text-xxl": "34.5px",
        "font-size-line-height-body-text-xxs": "16.5px",
        "font-size-line-height-body-text-xxxl": "39px",
        "font-size-line-height-body-text-xxxs": "15px",
        "font-size-line-height-body-text-xxxxl": "48px",
        "font-size-line-height-display-text-1": "124.5px",
        "font-size-line-height-display-text-2": "99px",
        "font-size-line-height-display-text-3": "69px",
        "font-size-line-height-heading-text-l": "27px",
        "font-size-line-height-heading-text-m": "24px",
        "font-size-line-height-heading-text-s": "21px",
        "font-size-line-height-heading-text-xl": "30px",
        "font-size-line-height-heading-text-xxl": "34.5px",
        "font-size-line-height-heading-text-xxxl": "39px",
        "font-size-line-height-heading-text-xxxxl": "48px",
        "font-size-line-height-heading-text-xxxxxl": "99px",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-expression-italic": "normal",
        "font-style-text-transform-uppercase": "initial",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.875rem",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.875rem",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.875rem",
        "size-icon-xxxxl": "1.8125rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "3rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4rem"
    }
};

const ChineseHongKongTokens = {
    "name": "chineseHongKong",
    "selectors": [":lang(zh-hk)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AnovaUI', '微軟正黑體', 'Microsoft JhengHei', '黑體-繁', 'Heiti TC', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'Anova', '微軟正黑體', 'Microsoft JhengHei', '黑體-繁', 'Heiti TC', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.8125rem",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125rem",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "3.25rem",
        "font-size-heading-text-xxxxxxl": "4.125rem",
        "font-size-line-height-body-text-l": "27px",
        "font-size-line-height-body-text-m": "24px",
        "font-size-line-height-body-text-s": "21px",
        "font-size-line-height-body-text-xl": "30px",
        "font-size-line-height-body-text-xs": "19.5px",
        "font-size-line-height-body-text-xxl": "34.5px",
        "font-size-line-height-body-text-xxs": "16.5px",
        "font-size-line-height-body-text-xxxl": "39px",
        "font-size-line-height-body-text-xxxs": "15px",
        "font-size-line-height-body-text-xxxxl": "48px",
        "font-size-line-height-display-text-1": "124.5px",
        "font-size-line-height-display-text-2": "99px",
        "font-size-line-height-display-text-3": "69px",
        "font-size-line-height-heading-text-l": "27px",
        "font-size-line-height-heading-text-m": "24px",
        "font-size-line-height-heading-text-s": "21px",
        "font-size-line-height-heading-text-xl": "30px",
        "font-size-line-height-heading-text-xxl": "34.5px",
        "font-size-line-height-heading-text-xxxl": "39px",
        "font-size-line-height-heading-text-xxxxl": "48px",
        "font-size-line-height-heading-text-xxxxxl": "99px",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-expression-italic": "normal",
        "font-style-text-transform-uppercase": "initial",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.875rem",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.875rem",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.875rem",
        "size-icon-xxxxl": "1.8125rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "3rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4rem"
    }
};

const ChinesePseudoTokens = {
    "name": "chinesePseudo",
    "selectors": [":lang(zh-cn-pseudo)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AnovaUI', '微软雅黑体', 'Microsoft YaHei New', '微软雅黑', 'Microsoft Yahei', '宋体', 'SimSun', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'Anova', '微软雅黑体', 'Microsoft YaHei New', '微软雅黑', 'Microsoft Yahei', '宋体', 'SimSun', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.8125rem",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125rem",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "3.25rem",
        "font-size-heading-text-xxxxxxl": "4.125rem",
        "font-size-line-height-body-text-l": "27px",
        "font-size-line-height-body-text-m": "24px",
        "font-size-line-height-body-text-s": "21px",
        "font-size-line-height-body-text-xl": "30px",
        "font-size-line-height-body-text-xs": "19.5px",
        "font-size-line-height-body-text-xxl": "34.5px",
        "font-size-line-height-body-text-xxs": "16.5px",
        "font-size-line-height-body-text-xxxl": "39px",
        "font-size-line-height-body-text-xxxs": "15px",
        "font-size-line-height-body-text-xxxxl": "48px",
        "font-size-line-height-display-text-1": "124.5px",
        "font-size-line-height-display-text-2": "99px",
        "font-size-line-height-display-text-3": "69px",
        "font-size-line-height-heading-text-l": "27px",
        "font-size-line-height-heading-text-m": "24px",
        "font-size-line-height-heading-text-s": "21px",
        "font-size-line-height-heading-text-xl": "30px",
        "font-size-line-height-heading-text-xxl": "34.5px",
        "font-size-line-height-heading-text-xxxl": "39px",
        "font-size-line-height-heading-text-xxxxl": "48px",
        "font-size-line-height-heading-text-xxxxxl": "99px",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-expression-italic": "normal",
        "font-style-text-transform-uppercase": "initial",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.875rem",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.875rem",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.875rem",
        "size-icon-xxxxl": "1.8125rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "3rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4rem"
    }
};

const DarkTokens = {
    "name": "dark",
    "selectors": ["[data-sas-theme='dark']"],
    "tokens": {
        "brand-color-alert": "hsl(0, 100%, 40%)",
        "brand-color-alert-00": "hsl(0, 0%, 100%)",
        "brand-color-alert-10": "hsl(0, 100%, 98%)",
        "brand-color-alert-100": "hsl(0, 100%, 64%)",
        "brand-color-alert-1000": "hsl(0, 0%, 0%)",
        "brand-color-alert-20": "hsl(0, 100%, 95%)",
        "brand-color-alert-200": "hsl(0, 100%, 59%)",
        "brand-color-alert-30": "hsl(0, 100%, 92%)",
        "brand-color-alert-300": "hsl(0, 100%, 54%)",
        "brand-color-alert-40": "hsl(0, 100%, 88%)",
        "brand-color-alert-400": "hsl(0, 100%, 46%)",
        "brand-color-alert-450": "hsl(0, 100%, 40%)",
        "brand-color-alert-50": "hsl(0, 100%, 84%)",
        "brand-color-alert-500": "hsl(0, 100%, 36%)",
        "brand-color-alert-550": "hsl(0, 100%, 33%)",
        "brand-color-alert-60": "hsl(0, 100%, 79%)",
        "brand-color-alert-600": "hsl(0, 100%, 30%)",
        "brand-color-alert-650": "hsl(0, 100%, 27%)",
        "brand-color-alert-70": "hsl(0, 100%, 76%)",
        "brand-color-alert-700": "hsl(0, 100%, 22%)",
        "brand-color-alert-750": "hsl(0, 100%, 17%)",
        "brand-color-alert-80": "hsl(0, 100%, 72%)",
        "brand-color-alert-800": "hsl(0, 100%, 12%)",
        "brand-color-alert-850": "hsl(0, 100%, 8%)",
        "brand-color-alert-90": "hsl(0, 100%, 68%)",
        "brand-color-alert-900": "hsl(0, 100%, 3%)",
        "brand-color-blue": "hsl(212, 94%, 42%)",
        "brand-color-blue-00": "hsl(212, 0%, 100%)",
        "brand-color-blue-10": "hsl(212, 94%, 97%)",
        "brand-color-blue-100": "hsl(212, 94%, 62%)",
        "brand-color-blue-1000": "hsl(212, 0%, 0%)",
        "brand-color-blue-20": "hsl(212, 94%, 94%)",
        "brand-color-blue-200": "hsl(212, 94%, 57%)",
        "brand-color-blue-30": "hsl(212, 94%, 90%)",
        "brand-color-blue-300": "hsl(212, 94%, 53%)",
        "brand-color-blue-40": "hsl(212, 94%, 88%)",
        "brand-color-blue-400": "hsl(212, 94%, 47%)",
        "brand-color-blue-450": "hsl(212, 94%, 42%)",
        "brand-color-blue-50": "hsl(212, 94%, 83%)",
        "brand-color-blue-500": "hsl(212, 94%, 36%)",
        "brand-color-blue-550": "hsl(212, 94%, 35%)",
        "brand-color-blue-60": "hsl(212, 94%, 78%)",
        "brand-color-blue-600": "hsl(212, 94%, 31%)",
        "brand-color-blue-650": "hsl(212, 94%, 27%)",
        "brand-color-blue-70": "hsl(212, 94%, 76%)",
        "brand-color-blue-700": "hsl(212, 94%, 23%)",
        "brand-color-blue-750": "hsl(212, 94%, 17%)",
        "brand-color-blue-80": "hsl(212, 94%, 72%)",
        "brand-color-blue-800": "hsl(212, 94%, 12%)",
        "brand-color-blue-850": "hsl(212, 94%, 8%)",
        "brand-color-blue-90": "hsl(212, 94%, 68%)",
        "brand-color-blue-900": "hsl(212, 94%, 3%)",
        "brand-color-cranberry": "hsl(329, 60%, 40%)",
        "brand-color-cranberry-00": "hsl(329,60%,100%)",
        "brand-color-cranberry-10": "hsl(329,60%,98%)",
        "brand-color-cranberry-100": "hsl(329,60%,62%)",
        "brand-color-cranberry-1000": "hsl(329,60%,0%)",
        "brand-color-cranberry-20": "hsl(329,60%,97%)",
        "brand-color-cranberry-200": "hsl(329,60%,57%)",
        "brand-color-cranberry-30": "hsl(329,60%,92%)",
        "brand-color-cranberry-300": "hsl(329,60%,55%)",
        "brand-color-cranberry-40": "hsl(329,60%,88%)",
        "brand-color-cranberry-400": "hsl(329,60%,52%)",
        "brand-color-cranberry-450": "hsl(329,60%,40%)",
        "brand-color-cranberry-50": "hsl(329,60%,84%)",
        "brand-color-cranberry-500": "hsl(329,60%,37%)",
        "brand-color-cranberry-550": "hsl(329,60%,32%)",
        "brand-color-cranberry-60": "hsl(329,60%,78%)",
        "brand-color-cranberry-600": "hsl(329,60%,30%)",
        "brand-color-cranberry-650": "hsl(329,60%,27%)",
        "brand-color-cranberry-70": "hsl(329,60%,76%)",
        "brand-color-cranberry-700": "hsl(329,60%,22%)",
        "brand-color-cranberry-750": "hsl(329,60%,16%)",
        "brand-color-cranberry-80": "hsl(329,60%,72%)",
        "brand-color-cranberry-800": "hsl(329,60%,11%)",
        "brand-color-cranberry-850": "hsl(329,60%,9%)",
        "brand-color-cranberry-90": "hsl(329,60%,68%)",
        "brand-color-cranberry-900": "hsl(329,60%,4%)",
        "brand-color-grey": "hsl(219, 12%, 42%)",
        "brand-color-grey-00": "hsl(219, 0%, 100%)",
        "brand-color-grey-10": "hsl(219, 12%, 98%)",
        "brand-color-grey-100": "hsl(219, 12%, 64%)",
        "brand-color-grey-1000": "hsl(219, 0%, 0%)",
        "brand-color-grey-20": "hsl(219, 12%, 96%)",
        "brand-color-grey-200": "hsl(219, 12%, 59%)",
        "brand-color-grey-30": "hsl(219, 12%, 92%)",
        "brand-color-grey-300": "hsl(219, 12%, 55%)",
        "brand-color-grey-40": "hsl(219, 12%, 88%)",
        "brand-color-grey-400": "hsl(219, 12%, 48%)",
        "brand-color-grey-450": "hsl(219, 12%, 42%)",
        "brand-color-grey-50": "hsl(219, 12%, 84%)",
        "brand-color-grey-500": "hsl(219, 12%, 36%)",
        "brand-color-grey-550": "hsl(219, 12%, 33%)",
        "brand-color-grey-60": "hsl(219, 12%, 79%)",
        "brand-color-grey-600": "hsl(219, 12%, 30%)",
        "brand-color-grey-650": "hsl(219, 12%, 27%)",
        "brand-color-grey-70": "hsl(219, 12%, 76%)",
        "brand-color-grey-700": "hsl(219, 12%, 22%)",
        "brand-color-grey-750": "hsl(219, 12%, 17%)",
        "brand-color-grey-80": "hsl(219, 12%, 72%)",
        "brand-color-grey-800": "hsl(219, 12%, 12%)",
        "brand-color-grey-850": "hsl(219, 12%, 8%)",
        "brand-color-grey-90": "hsl(219, 12%, 68%)",
        "brand-color-grey-900": "hsl(219, 12%, 3%)",
        "brand-color-info": "hsl(212, 94%, 42%)",
        "brand-color-info-00": "hsl(212, 0%, 100%)",
        "brand-color-info-10": "hsl(212, 94%, 97%)",
        "brand-color-info-100": "hsl(212, 94%, 62%)",
        "brand-color-info-1000": "hsl(212, 0%, 0%)",
        "brand-color-info-20": "hsl(212, 94%, 94%)",
        "brand-color-info-200": "hsl(212, 94%, 57%)",
        "brand-color-info-30": "hsl(212, 94%, 90%)",
        "brand-color-info-300": "hsl(212, 94%, 53%)",
        "brand-color-info-40": "hsl(212, 94%, 88%)",
        "brand-color-info-400": "hsl(212, 94%, 47%)",
        "brand-color-info-450": "hsl(212, 94%, 42%)",
        "brand-color-info-50": "hsl(212, 94%, 83%)",
        "brand-color-info-500": "hsl(212, 94%, 36%)",
        "brand-color-info-550": "hsl(212, 94%, 35%)",
        "brand-color-info-60": "hsl(212, 94%, 78%)",
        "brand-color-info-600": "hsl(212, 94%, 31%)",
        "brand-color-info-650": "hsl(212, 94%, 27%)",
        "brand-color-info-70": "hsl(212, 94%, 76%)",
        "brand-color-info-700": "hsl(212, 94%, 23%)",
        "brand-color-info-750": "hsl(212, 94%, 17%)",
        "brand-color-info-80": "hsl(212, 94%, 72%)",
        "brand-color-info-800": "hsl(212, 94%, 12%)",
        "brand-color-info-850": "hsl(212, 94%, 8%)",
        "brand-color-info-90": "hsl(212, 94%, 68%)",
        "brand-color-info-900": "hsl(212, 94%, 3%)",
        "brand-color-success": "hsl(123, 46%, 43%)",
        "brand-color-success-00": "hsl(123, 0%, 100%)",
        "brand-color-success-10": "hsl(123, 46%, 98%)",
        "brand-color-success-100": "hsl(123, 46%, 63%)",
        "brand-color-success-1000": "hsl(123, 0%, 0%)",
        "brand-color-success-20": "hsl(123, 46%, 95%)",
        "brand-color-success-200": "hsl(123, 46%, 58%)",
        "brand-color-success-30": "hsl(123, 46%, 90%)",
        "brand-color-success-300": "hsl(123, 46%, 55%)",
        "brand-color-success-40": "hsl(123, 46%, 87%)",
        "brand-color-success-400": "hsl(123, 46%, 48%)",
        "brand-color-success-450": "hsl(123, 46%, 43%)",
        "brand-color-success-50": "hsl(123, 46%, 82%)",
        "brand-color-success-500": "hsl(123, 46%, 36%)",
        "brand-color-success-550": "hsl(123, 46%, 34%)",
        "brand-color-success-60": "hsl(123, 46%, 78%)",
        "brand-color-success-600": "hsl(123, 46%, 30%)",
        "brand-color-success-650": "hsl(123, 46%, 25%)",
        "brand-color-success-70": "hsl(123, 46%, 75%)",
        "brand-color-success-700": "hsl(123, 46%, 22%)",
        "brand-color-success-750": "hsl(123, 46%, 17%)",
        "brand-color-success-80": "hsl(123, 46%, 70%)",
        "brand-color-success-800": "hsl(123, 46%, 12%)",
        "brand-color-success-850": "hsl(123, 46%, 8%)",
        "brand-color-success-90": "hsl(123, 46%, 66%)",
        "brand-color-success-900": "hsl(123, 46%, 3%)",
        "brand-color-warning": "hsl(43, 89%, 44%)",
        "brand-color-warning-00": "hsl(43, 0%, 100%)",
        "brand-color-warning-10": "hsl(43, 89%, 98%)",
        "brand-color-warning-100": "hsl(43, 89%, 64%)",
        "brand-color-warning-1000": "hsl(43, 0%, 0%)",
        "brand-color-warning-20": "hsl(43, 89%, 95%)",
        "brand-color-warning-200": "hsl(43, 89%, 60%)",
        "brand-color-warning-30": "hsl(43, 89%, 92%)",
        "brand-color-warning-300": "hsl(43, 89%, 56%)",
        "brand-color-warning-40": "hsl(43, 89%, 88%)",
        "brand-color-warning-400": "hsl(43, 89%, 52%)",
        "brand-color-warning-450": "hsl(43, 89%, 44%)",
        "brand-color-warning-50": "hsl(43, 89%, 84%)",
        "brand-color-warning-500": "hsl(43, 89%, 39%)",
        "brand-color-warning-550": "hsl(43, 89%, 35%)",
        "brand-color-warning-60": "hsl(43, 89%, 79%)",
        "brand-color-warning-600": "hsl(43, 89%, 31%)",
        "brand-color-warning-650": "hsl(43, 89%, 27%)",
        "brand-color-warning-70": "hsl(43, 89%, 76%)",
        "brand-color-warning-700": "hsl(43, 89%, 24%)",
        "brand-color-warning-750": "hsl(43, 89%, 17%)",
        "brand-color-warning-80": "hsl(43, 89%, 72%)",
        "brand-color-warning-800": "hsl(43, 89%, 12%)",
        "brand-color-warning-850": "hsl(43, 89%, 8%)",
        "brand-color-warning-90": "hsl(43, 89%, 68%)",
        "brand-color-warning-900": "hsl(43, 89%, 3%)",
        "color-action-background-control-alert": "hsl(0, 100%, 8%)",
        "color-action-background-control-disabled": "hsl(219, 12%, 17%)",
        "color-action-background-control-hover": "hsl(219, 12%, 8%)",
        "color-action-background-control-normal": "hsl(219, 12%, 12%)",
        "color-action-background-control-primary": "hsl(212, 94%, 31%)",
        "color-action-background-control-read-only": "hsl(219, 12%, 17%)",
        "color-action-background-control-selected": "hsl(212, 94%, 17%)",
        "color-action-background-control-warning": "hsl(43, 89%, 8%)",
        "color-action-background-emphasis-active": "hsl(219, 12%, 30%)",
        "color-action-background-emphasis-disabled": "hsl(219, 12%, 30%)",
        "color-action-background-emphasis-hover": "hsl(212, 94%, 31%)",
        "color-action-background-emphasis-normal": "hsl(212, 94%, 42%)",
        "color-action-background-emphasis-selected": "hsl(212, 94%, 31%)",
        "color-action-background-emphasis-visited": "hsl(212, 94%, 42%)",
        "color-action-background-focus": "hsl(205, 97%, 63%)",
        "color-action-background-focus-inverse": "hsl(0, 0%, 0%)",
        "color-action-background-on-off-disabled": "hsl(219, 12%, 17%)",
        "color-action-background-on-off-hover": "hsl(219, 12%, 8%)",
        "color-action-background-on-off-normal": "hsl(219, 12%, 17%)",
        "color-action-background-on-off-read-only": "hsl(219, 12%, 12%)",
        "color-action-background-on-off-selected": "hsl(212, 94%, 53%)",
        "color-action-background-on-off-selected-disabled": "hsl(219, 12%, 22%)",
        "color-action-background-standard-active": "hsl(212, 94%, 23%)",
        "color-action-background-standard-disabled": "hsl(219, 12%, 17%)",
        "color-action-background-standard-hover": "hsl(219, 12%, 8%)",
        "color-action-background-standard-normal": "hsl(219, 12%, 12%)",
        "color-action-background-standard-selected": "hsl(212, 94%, 23%)",
        "color-action-background-standard-selected-disabled": "hsl(212, 94%, 12%)",
        "color-action-background-standard-selected-inactive": "hsl(219, 12%, 30%)",
        "color-action-background-standard-visited": "hsl(219, 12%, 12%)",
        "color-action-background-subtle-disabled": "hsla(0, 0%, 0%, 0)",
        "color-action-background-subtle-hover": "hsl(219, 12%, 8%)",
        "color-action-background-subtle-normal": "hsla(0, 0%, 0%, 0)",
        "color-action-background-subtle-selected": "hsl(212, 94%, 23%)",
        "color-action-background-subtle-selected-disabled": "hsl(212, 94%, 12%)",
        "color-action-background-subtle-selected-inactive": "hsl(219, 12%, 30%)",
        "color-action-border-bottom-control-alert": "hsl(0, 100%, 64%)",
        "color-action-border-bottom-control-hover": "hsl(219, 12%, 48%)",
        "color-action-border-bottom-control-normal": "hsl(219, 12%, 48%)",
        "color-action-border-bottom-control-selected": "hsl(212, 94%, 42%)",
        "color-action-border-bottom-control-warning": "hsl(43, 89%, 64%)",
        "color-action-border-control-alert": "hsl(0, 100%, 8%)",
        "color-action-border-control-disabled": "hsl(219, 12%, 17%)",
        "color-action-border-control-hover": "hsl(219, 12%, 8%)",
        "color-action-border-control-normal": "hsl(219, 12%, 48%)",
        "color-action-border-control-read-only": "hsl(219, 12%, 17%)",
        "color-action-border-control-selected": "hsl(212, 94%, 17%)",
        "color-action-border-control-warning": "hsl(43, 89%, 8%)",
        "color-action-border-emphasis-active": "hsl(212, 94%, 31%)",
        "color-action-border-emphasis-disabled": "hsl(219, 12%, 17%)",
        "color-action-border-emphasis-hover": "hsl(212, 94%, 31%)",
        "color-action-border-emphasis-normal": "hsl(212, 94%, 42%)",
        "color-action-border-emphasis-selected": "hsl(212, 94%, 31%)",
        "color-action-border-emphasis-visited": "hsl(212, 94%, 42%)",
        "color-action-border-focus": "hsl(212, 94%, 62%)",
        "color-action-border-focus-inverse": "hsl(212, 0%, 100%)",
        "color-action-border-on-off-disabled": "hsl(219, 12%, 30%)",
        "color-action-border-on-off-hover": "hsl(219, 12%, 48%)",
        "color-action-border-on-off-normal": "hsl(219, 12%, 48%)",
        "color-action-border-on-off-read-only": "hsl(219, 12%, 48%)",
        "color-action-border-on-off-selected": "hsl(212, 94%, 53%)",
        "color-action-border-on-off-selected-disabled": "hsl(219, 12%, 22%)",
        "color-action-border-standard-active": "hsl(212, 94%, 57%)",
        "color-action-border-standard-disabled": "hsl(219, 12%, 17%)",
        "color-action-border-standard-hover": "hsl(219, 12%, 30%)",
        "color-action-border-standard-normal": "hsl(219, 12%, 22%)",
        "color-action-border-standard-selected": "hsl(212, 94%, 57%)",
        "color-action-border-standard-selected-disabled": "hsl(212, 94%, 12%)",
        "color-action-border-standard-selected-inactive": "hsl(219, 12%, 48%)",
        "color-action-border-standard-visited": "hsl(219, 12%, 22%)",
        "color-action-border-subtle-disabled": "hsla(0, 0%, 0%, 0)",
        "color-action-border-subtle-hover": "hsl(219, 12%, 8%)",
        "color-action-border-subtle-normal": "hsla(0, 0%, 0%, 0)",
        "color-action-border-subtle-selected": "hsl(212, 94%, 23%)",
        "color-action-border-subtle-selected-disabled": "hsl(212, 94%, 12%)",
        "color-action-border-subtle-selected-inactive": "hsl(219, 12%, 30%)",
        "color-action-focus": "hsl(212, 94%, 62%)",
        "color-action-icon-control-alert": "hsl(0, 0%, 100%)",
        "color-action-icon-control-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-control-hover": "hsl(219, 12%, 88%)",
        "color-action-icon-control-normal": "hsl(219, 12%, 88%)",
        "color-action-icon-control-read-only": "hsl(219, 12%, 88%)",
        "color-action-icon-control-selected": "hsl(212, 0%, 100%)",
        "color-action-icon-control-warning": "hsl(43, 0%, 100%)",
        "color-action-icon-emphasis-active": "hsl(212, 0%, 100%)",
        "color-action-icon-emphasis-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-emphasis-hover": "hsl(212, 94%, 88%)",
        "color-action-icon-emphasis-normal": "hsl(212, 0%, 100%)",
        "color-action-icon-emphasis-selected": "hsl(212, 0%, 100%)",
        "color-action-icon-emphasis-visited": "hsl(212, 0%, 100%)",
        "color-action-icon-on-off-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-on-off-hover": "hsl(219, 12%, 88%)",
        "color-action-icon-on-off-normal": "hsl(219, 12%, 88%)",
        "color-action-icon-on-off-read-only": "hsl(219, 12%, 88%)",
        "color-action-icon-on-off-selected": "hsl(212, 0%, 100%)",
        "color-action-icon-on-off-selected-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-standard-active": "hsl(212, 0%, 100%)",
        "color-action-icon-standard-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-standard-hover": "hsl(219, 12%, 88%)",
        "color-action-icon-standard-normal": "hsl(219, 12%, 88%)",
        "color-action-icon-standard-selected": "hsl(212, 0%, 100%)",
        "color-action-icon-standard-selected-disabled": "hsl(212, 94%, 31%)",
        "color-action-icon-standard-selected-inactive": "hsl(219, 0%, 100%)",
        "color-action-icon-standard-visited": "hsl(219, 12%, 88%)",
        "color-action-icon-subtle-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-subtle-hover": "hsl(219, 12%, 88%)",
        "color-action-icon-subtle-normal": "hsl(219, 12%, 88%)",
        "color-action-icon-subtle-selected": "hsl(212, 0%, 100%)",
        "color-action-icon-subtle-selected-disabled": "hsl(212, 94%, 31%)",
        "color-action-icon-subtle-selected-inactive": "hsl(219, 0%, 100%)",
        "color-action-link-active": "hsl(219, 12%, 88%)",
        "color-action-link-hover": "hsl(212, 94%, 83%)",
        "color-action-link-normal": "hsl(212, 94%, 83%)",
        "color-action-link-visited": "hsl(212, 94%, 83%)",
        "color-action-text-control-alert": "hsl(0, 0%, 100%)",
        "color-action-text-control-disabled": "hsl(219, 12%, 30%)",
        "color-action-text-control-hover": "hsl(219, 12%, 88%)",
        "color-action-text-control-normal": "hsl(219, 12%, 88%)",
        "color-action-text-control-placeholder": "hsl(219, 12%, 64%)",
        "color-action-text-control-read-only": "hsl(219, 12%, 88%)",
        "color-action-text-control-selected": "hsl(212, 0%, 100%)",
        "color-action-text-control-warning": "hsl(43, 0%, 100%)",
        "color-action-text-emphasis-active": "hsl(212, 0%, 100%)",
        "color-action-text-emphasis-disabled": "hsl(219, 12%, 17%)",
        "color-action-text-emphasis-hover": "hsl(212, 94%, 88%)",
        "color-action-text-emphasis-normal": "hsl(212, 0%, 100%)",
        "color-action-text-emphasis-selected": "hsl(212, 0%, 100%)",
        "color-action-text-emphasis-visited": "hsl(212, 0%, 100%)",
        "color-action-text-on-off-disabled": "hsl(219, 12%, 30%)",
        "color-action-text-on-off-hover": "hsl(219, 12%, 88%)",
        "color-action-text-on-off-normal": "hsl(219, 12%, 88%)",
        "color-action-text-on-off-read-only": "hsl(219, 12%, 88%)",
        "color-action-text-on-off-selected": "hsl(212, 0%, 100%)",
        "color-action-text-on-off-selected-disabled": "hsl(219, 12%, 30%)",
        "color-action-text-standard-active": "hsl(212, 0%, 100%)",
        "color-action-text-standard-disabled": "hsl(219, 12%, 30%)",
        "color-action-text-standard-hover": "hsl(219, 12%, 88%)",
        "color-action-text-standard-normal": "hsl(219, 12%, 88%)",
        "color-action-text-standard-selected": "hsl(212, 0%, 100%)",
        "color-action-text-standard-selected-disabled": "hsl(212, 94%, 31%)",
        "color-action-text-standard-selected-inactive": "hsl(219, 0%, 100%)",
        "color-action-text-standard-visited": "hsl(219, 12%, 88%)",
        "color-action-text-subtle-disabled": "hsl(219, 12%, 30%)",
        "color-action-text-subtle-hover": "hsl(219, 12%, 88%)",
        "color-action-text-subtle-normal": "hsl(219, 12%, 88%)",
        "color-action-text-subtle-selected": "hsl(212, 0%, 100%)",
        "color-action-text-subtle-selected-disabled": "hsl(212, 94%, 31%)",
        "color-action-text-subtle-selected-inactive": "hsl(219, 0%, 100%)",
        "color-alert-00": "hsl(0, 0%, 100%)",
        "color-alert-10": "hsl(0, 100%, 98%)",
        "color-alert-100": "hsl(0, 100%, 64%)",
        "color-alert-1000": "hsl(0, 0%, 0%)",
        "color-alert-20": "hsl(0, 100%, 95%)",
        "color-alert-200": "hsl(0, 100%, 59%)",
        "color-alert-30": "hsl(0, 100%, 92%)",
        "color-alert-300": "hsl(0, 100%, 54%)",
        "color-alert-40": "hsl(0, 100%, 88%)",
        "color-alert-400": "hsl(0, 100%, 46%)",
        "color-alert-450": "hsl(0, 100%, 40%)",
        "color-alert-50": "hsl(0, 100%, 84%)",
        "color-alert-500": "hsl(0, 100%, 36%)",
        "color-alert-550": "hsl(0, 100%, 33%)",
        "color-alert-60": "hsl(0, 100%, 79%)",
        "color-alert-600": "hsl(0, 100%, 30%)",
        "color-alert-650": "hsl(0, 100%, 27%)",
        "color-alert-70": "hsl(0, 100%, 76%)",
        "color-alert-700": "hsl(0, 100%, 22%)",
        "color-alert-750": "hsl(0, 100%, 17%)",
        "color-alert-80": "hsl(0, 100%, 72%)",
        "color-alert-800": "hsl(0, 100%, 12%)",
        "color-alert-850": "hsl(0, 100%, 8%)",
        "color-alert-90": "hsl(0, 100%, 68%)",
        "color-alert-900": "hsl(0, 100%, 3%)",
        "color-body-icon": "hsl(219, 12%, 88%)",
        "color-body-text": "hsl(219, 12%, 88%)",
        "color-container-background-0": "hsl(219, 12%, 17%)",
        "color-container-background-1": "hsl(219, 12%, 12%)",
        "color-container-background-2": "hsl(219, 12%, 8%)",
        "color-container-background-3": "hsl(212, 94%, 36%)",
        "color-container-background-4": "hsl(219, 12%, 30%)",
        "color-container-border-4": "hsl(219, 12%, 30%)",
        "color-dataviz-graph-alt1": "#35A5FF",
        "color-dataviz-graph-alt2": "#EBCF5D",
        "color-dataviz-graph-alt3": "#837CFF",
        "color-dataviz-graph-alt4": "#EB8C4A",
        "color-dataviz-graph-alt5": "#36D7E3",
        "color-dataviz-graph-alt6": "#D6697A",
        "color-dataviz-graph-alt7": "#27C99F",
        "color-dataviz-graph-alt8": "#EB7DCF",
        "color-dataviz-graph1": "#2470ad",
        "color-dataviz-graph2": "#98863c",
        "color-dataviz-graph3": "#5954ad",
        "color-dataviz-graph4": "#985b30",
        "color-dataviz-graph5": "#238a92",
        "color-dataviz-graph6": "#84414b",
        "color-dataviz-graph7": "#17785f",
        "color-dataviz-graph8": "#985186",
        "color-dataviz-kpi-alt1": "#D6697A",
        "color-dataviz-kpi-alt3": "#EBCF5D",
        "color-dataviz-kpi-alt5": "#27C99F",
        "color-dataviz-kpi1": "#84414b",
        "color-dataviz-kpi3": "#98863c",
        "color-dataviz-kpi5": "#17785f",
        "color-display-icon": "hsl(219, 12%, 88%)",
        "color-display-text": "hsl(219, 12%, 88%)",
        "color-heading-icon": "hsl(219, 12%, 88%)",
        "color-heading-text": "hsl(219, 12%, 88%)",
        "color-highlight-text": "hsl(212, 94%, 62%)",
        "color-highlight-text-inverse": "hsl(212, 0%, 0%)",
        "color-icon-neutral": "hsl(219, 12%, 88%)",
        "color-icon-primary": "hsl(212, 94%, 42%)",
        "color-icon-secondary": "hsl(329,60%,30%)",
        "color-info-00": "hsl(212, 0%, 100%)",
        "color-info-10": "hsl(212, 94%, 97%)",
        "color-info-100": "hsl(212, 94%, 62%)",
        "color-info-1000": "hsl(212, 0%, 0%)",
        "color-info-20": "hsl(212, 94%, 94%)",
        "color-info-200": "hsl(212, 94%, 57%)",
        "color-info-30": "hsl(212, 94%, 90%)",
        "color-info-300": "hsl(212, 94%, 53%)",
        "color-info-40": "hsl(212, 94%, 88%)",
        "color-info-400": "hsl(212, 94%, 47%)",
        "color-info-450": "hsl(212, 94%, 42%)",
        "color-info-50": "hsl(212, 94%, 83%)",
        "color-info-500": "hsl(212, 94%, 36%)",
        "color-info-550": "hsl(212, 94%, 35%)",
        "color-info-60": "hsl(212, 94%, 78%)",
        "color-info-600": "hsl(212, 94%, 31%)",
        "color-info-650": "hsl(212, 94%, 27%)",
        "color-info-70": "hsl(212, 94%, 76%)",
        "color-info-700": "hsl(212, 94%, 23%)",
        "color-info-750": "hsl(212, 94%, 17%)",
        "color-info-80": "hsl(212, 94%, 72%)",
        "color-info-800": "hsl(212, 94%, 12%)",
        "color-info-850": "hsl(212, 94%, 8%)",
        "color-info-90": "hsl(212, 94%, 68%)",
        "color-info-900": "hsl(212, 94%, 3%)",
        "color-label-text": "hsl(219, 12%, 59%)",
        "color-neutral": "hsl(219, 12%, 64%)",
        "color-neutral-00": "hsl(219, 0%, 100%)",
        "color-neutral-10": "hsl(219, 12%, 98%)",
        "color-neutral-100": "hsl(219, 12%, 64%)",
        "color-neutral-1000": "hsl(219, 0%, 0%)",
        "color-neutral-20": "hsl(219, 12%, 96%)",
        "color-neutral-200": "hsl(219, 12%, 59%)",
        "color-neutral-30": "hsl(219, 12%, 92%)",
        "color-neutral-300": "hsl(219, 12%, 55%)",
        "color-neutral-40": "hsl(219, 12%, 88%)",
        "color-neutral-400": "hsl(219, 12%, 48%)",
        "color-neutral-450": "hsl(219, 12%, 42%)",
        "color-neutral-50": "hsl(219, 12%, 84%)",
        "color-neutral-500": "hsl(219, 12%, 36%)",
        "color-neutral-550": "hsl(219, 12%, 33%)",
        "color-neutral-60": "hsl(219, 12%, 79%)",
        "color-neutral-600": "hsl(219, 12%, 30%)",
        "color-neutral-650": "hsl(219, 12%, 27%)",
        "color-neutral-70": "hsl(219, 12%, 76%)",
        "color-neutral-700": "hsl(219, 12%, 22%)",
        "color-neutral-750": "hsl(219, 12%, 17%)",
        "color-neutral-80": "hsl(219, 12%, 72%)",
        "color-neutral-800": "hsl(219, 12%, 12%)",
        "color-neutral-850": "hsl(219, 12%, 8%)",
        "color-neutral-90": "hsl(219, 12%, 68%)",
        "color-neutral-900": "hsl(219, 12%, 3%)",
        "color-primary": "hsl(212, 94%, 62%)",
        "color-primary-00": "hsl(212, 0%, 100%)",
        "color-primary-10": "hsl(212, 94%, 97%)",
        "color-primary-100": "hsl(212, 94%, 62%)",
        "color-primary-1000": "hsl(212, 0%, 0%)",
        "color-primary-20": "hsl(212, 94%, 94%)",
        "color-primary-200": "hsl(212, 94%, 57%)",
        "color-primary-30": "hsl(212, 94%, 90%)",
        "color-primary-300": "hsl(212, 94%, 53%)",
        "color-primary-40": "hsl(212, 94%, 88%)",
        "color-primary-400": "hsl(212, 94%, 47%)",
        "color-primary-450": "hsl(212, 94%, 42%)",
        "color-primary-50": "hsl(212, 94%, 83%)",
        "color-primary-500": "hsl(212, 94%, 36%)",
        "color-primary-550": "hsl(212, 94%, 35%)",
        "color-primary-60": "hsl(212, 94%, 78%)",
        "color-primary-600": "hsl(212, 94%, 31%)",
        "color-primary-650": "hsl(212, 94%, 27%)",
        "color-primary-70": "hsl(212, 94%, 76%)",
        "color-primary-700": "hsl(212, 94%, 23%)",
        "color-primary-750": "hsl(212, 94%, 17%)",
        "color-primary-80": "hsl(212, 94%, 72%)",
        "color-primary-800": "hsl(212, 94%, 12%)",
        "color-primary-850": "hsl(212, 94%, 8%)",
        "color-primary-90": "hsl(212, 94%, 68%)",
        "color-primary-900": "hsl(212, 94%, 3%)",
        "color-secondary": "hsl(329,60%,40%)",
        "color-secondary-00": "hsl(329,60%,100%)",
        "color-secondary-10": "hsl(329,60%,98%)",
        "color-secondary-100": "hsl(329,60%,62%)",
        "color-secondary-1000": "hsl(329,60%,0%)",
        "color-secondary-20": "hsl(329,60%,97%)",
        "color-secondary-200": "hsl(329,60%,57%)",
        "color-secondary-30": "hsl(329,60%,92%)",
        "color-secondary-300": "hsl(329,60%,55%)",
        "color-secondary-40": "hsl(329,60%,88%)",
        "color-secondary-400": "hsl(329,60%,52%)",
        "color-secondary-450": "hsl(329,60%,40%)",
        "color-secondary-50": "hsl(329,60%,84%)",
        "color-secondary-500": "hsl(329,60%,37%)",
        "color-secondary-550": "hsl(329,60%,32%)",
        "color-secondary-60": "hsl(329,60%,78%)",
        "color-secondary-600": "hsl(329,60%,30%)",
        "color-secondary-650": "hsl(329,60%,27%)",
        "color-secondary-70": "hsl(329,60%,76%)",
        "color-secondary-700": "hsl(329,60%,22%)",
        "color-secondary-750": "hsl(329,60%,16%)",
        "color-secondary-80": "hsl(329,60%,72%)",
        "color-secondary-800": "hsl(329,60%,11%)",
        "color-secondary-850": "hsl(329,60%,9%)",
        "color-secondary-90": "hsl(329,60%,68%)",
        "color-secondary-900": "hsl(329,60%,4%)",
        "color-status-alert": "hsl(0, 100%, 64%)",
        "color-status-background-alert": "hsl(0, 100%, 8%)",
        "color-status-background-info": "hsl(212, 94%, 8%)",
        "color-status-background-neutral": "hsl(219, 12%, 8%)",
        "color-status-background-success": "hsl(123, 46%, 8%)",
        "color-status-background-warning": "hsl(43, 89%, 8%)",
        "color-status-border-alert": "hsl(0, 100%, 64%)",
        "color-status-border-info": "hsl(212, 94%, 62%)",
        "color-status-border-neutral": "hsl(219, 12%, 64%)",
        "color-status-border-success": "hsl(123, 46%, 63%)",
        "color-status-border-warning": "hsl(43, 89%, 64%)",
        "color-status-icon-alert": "hsl(0, 100%, 72%)",
        "color-status-icon-info": "hsl(212, 94%, 72%)",
        "color-status-icon-neutral": "hsl(219, 12%, 72%)",
        "color-status-icon-success": "hsl(123, 46%, 70%)",
        "color-status-icon-warning": "hsl(43, 89%, 72%)",
        "color-status-info": "hsl(212, 94%, 62%)",
        "color-status-neutral": "hsl(219, 12%, 64%)",
        "color-status-success": "hsl(123, 46%, 63%)",
        "color-status-text-alert": "hsl(0, 100%, 72%)",
        "color-status-text-info": "hsl(212, 94%, 72%)",
        "color-status-text-neutral": "hsl(219, 12%, 72%)",
        "color-status-text-success": "hsl(123, 46%, 70%)",
        "color-status-text-warning": "hsl(43, 89%, 72%)",
        "color-status-warning": "hsl(43, 89%, 64%)",
        "color-success-00": "hsl(123, 0%, 100%)",
        "color-success-10": "hsl(123, 46%, 98%)",
        "color-success-100": "hsl(123, 46%, 63%)",
        "color-success-1000": "hsl(123, 0%, 0%)",
        "color-success-20": "hsl(123, 46%, 95%)",
        "color-success-200": "hsl(123, 46%, 58%)",
        "color-success-30": "hsl(123, 46%, 90%)",
        "color-success-300": "hsl(123, 46%, 55%)",
        "color-success-40": "hsl(123, 46%, 87%)",
        "color-success-400": "hsl(123, 46%, 48%)",
        "color-success-450": "hsl(123, 46%, 43%)",
        "color-success-50": "hsl(123, 46%, 82%)",
        "color-success-500": "hsl(123, 46%, 36%)",
        "color-success-550": "hsl(123, 46%, 34%)",
        "color-success-60": "hsl(123, 46%, 78%)",
        "color-success-600": "hsl(123, 46%, 30%)",
        "color-success-650": "hsl(123, 46%, 25%)",
        "color-success-70": "hsl(123, 46%, 75%)",
        "color-success-700": "hsl(123, 46%, 22%)",
        "color-success-750": "hsl(123, 46%, 17%)",
        "color-success-80": "hsl(123, 46%, 70%)",
        "color-success-800": "hsl(123, 46%, 12%)",
        "color-success-850": "hsl(123, 46%, 8%)",
        "color-success-90": "hsl(123, 46%, 66%)",
        "color-success-900": "hsl(123, 46%, 3%)",
        "color-syntax-text-01": "#DDDFE4",
        "color-syntax-text-02": "#98A0AE",
        "color-syntax-text-03": "#FAAA6B",
        "color-syntax-text-04": "#F17E70",
        "color-syntax-text-05": "#A570E8",
        "color-syntax-text-06": "#4398F9",
        "color-syntax-text-07": "#92C3FC",
        "color-syntax-text-08": "#54B6A4",
        "color-syntax-text-09": "#97C03F",
        "color-syntax-text-attribute-name": "#92C3FC",
        "color-syntax-text-attribute-value": "#F17E70",
        "color-syntax-text-boolean": "#A570E8",
        "color-syntax-text-character-constant": "#54B6A4",
        "color-syntax-text-class-name": "#54B6A4",
        "color-syntax-text-comment": "#97C03F",
        "color-syntax-text-control": "#A570E8",
        "color-syntax-text-data": "#FAAA6B",
        "color-syntax-text-declaration": "#4398F9",
        "color-syntax-text-default": "#DDDFE4",
        "color-syntax-text-function": "#A570E8",
        "color-syntax-text-identifier": "#DDDFE4",
        "color-syntax-text-keyword": "#4398F9",
        "color-syntax-text-namespace": "#54B6A4",
        "color-syntax-text-normal": "#DDDFE4",
        "color-syntax-text-numeric-constant": "#54B6A4",
        "color-syntax-text-operator": "#92C3FC",
        "color-syntax-text-proc-name": "#92C3FC",
        "color-syntax-text-property": "#4398F9",
        "color-syntax-text-punctuation": "#98A0AE",
        "color-syntax-text-punctuation-brackets": "#98A0AE",
        "color-syntax-text-section": "#92C3FC",
        "color-syntax-text-separator": "#DDDFE4",
        "color-syntax-text-source": "#4398F9",
        "color-syntax-text-storage-type": "#4398F9",
        "color-syntax-text-string": "#F17E70",
        "color-syntax-text-tag": "#4398F9",
        "color-syntax-text-variable": "#92C3FC",
        "color-tag-background-1": "hsl(212, 94%, 31%)",
        "color-tag-background-2": "hsl(329,60%,30%)",
        "color-tag-background-3": "hsl(219, 12%, 30%)",
        "color-tag-border-1": "hsl(212, 94%, 62%)",
        "color-tag-border-2": "hsl(329,60%,62%)",
        "color-tag-border-3": "hsl(219, 12%, 64%)",
        "color-text-neutral": "hsl(219, 12%, 88%)",
        "color-text-neutral-inverse": "hsl(219, 12%, 12%)",
        "color-text-primary": "hsl(212, 94%, 62%)",
        "color-text-primary-inverse": "hsl(212, 0%, 100%)",
        "color-text-secondary": "hsl(329,60%,30%)",
        "color-thumbnail-fill-1": "hsl(212, 94%, 83%)",
        "color-thumbnail-fill-2": "hsl(212, 94%, 72%)",
        "color-thumbnail-fill-3": "hsl(212, 94%, 57%)",
        "color-thumbnail-fill-4": "hsl(212, 94%, 42%)",
        "color-warning-00": "hsl(43, 0%, 100%)",
        "color-warning-10": "hsl(43, 89%, 98%)",
        "color-warning-100": "hsl(43, 89%, 64%)",
        "color-warning-1000": "hsl(43, 0%, 0%)",
        "color-warning-20": "hsl(43, 89%, 95%)",
        "color-warning-200": "hsl(43, 89%, 60%)",
        "color-warning-30": "hsl(43, 89%, 92%)",
        "color-warning-300": "hsl(43, 89%, 56%)",
        "color-warning-40": "hsl(43, 89%, 88%)",
        "color-warning-400": "hsl(43, 89%, 52%)",
        "color-warning-450": "hsl(43, 89%, 44%)",
        "color-warning-50": "hsl(43, 89%, 84%)",
        "color-warning-500": "hsl(43, 89%, 39%)",
        "color-warning-550": "hsl(43, 89%, 35%)",
        "color-warning-60": "hsl(43, 89%, 79%)",
        "color-warning-600": "hsl(43, 89%, 31%)",
        "color-warning-650": "hsl(43, 89%, 27%)",
        "color-warning-70": "hsl(43, 89%, 76%)",
        "color-warning-700": "hsl(43, 89%, 24%)",
        "color-warning-750": "hsl(43, 89%, 17%)",
        "color-warning-80": "hsl(43, 89%, 72%)",
        "color-warning-800": "hsl(43, 89%, 12%)",
        "color-warning-850": "hsl(43, 89%, 8%)",
        "color-warning-90": "hsl(43, 89%, 68%)",
        "color-warning-900": "hsl(43, 89%, 3%)",
        "color-zero-state-base-fill-1": "hsl(219, 12%, 17%)",
        "color-zero-state-base-fill-2": "hsl(219, 12%, 59%)",
        "color-zero-state-base-fill-3": "hsl(219, 12%, 48%)",
        "color-zero-state-modifier-fill-1": "hsl(219, 12%, 27%)",
        "color-zero-state-modifier-fill-2": "hsl(212, 94%, 62%)",
        "color-zero-state-modifier-fill-3": "hsl(212, 94%, 72%)",
        "color-zero-state-modifier-fill-4": "hsl(219, 12%, 33%)",
        "color-zero-state-modifier-fill-5": "hsl(219, 12%, 72%)",
        "duration-100": "100ms",
        "duration-1000": "1s",
        "duration-200": "200ms",
        "duration-250": "250ms",
        "duration-300": "300ms",
        "duration-400": "400ms",
        "duration-450": "450ms",
        "duration-500": "500ms",
        "duration-700": "700ms",
        "ease-in": "cubic-bezier(0, 0.5, 0.2, 1)",
        "ease-in-out": "cubic-bezier(0.5, 0, 0.2, 1)",
        "ease-out": "cubic-bezier(0.5, 0, 0.8, 1)",
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "font-family-secondary": "'Anova', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "font-size-base-text": "16px",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "22.4px",
        "font-size-line-height-body-text-m": "19.6px",
        "font-size-line-height-body-text-s": "16.8px",
        "font-size-line-height-body-text-xl": "25.2px",
        "font-size-line-height-body-text-xs": "15.4px",
        "font-size-line-height-body-text-xxl": "28px",
        "font-size-line-height-body-text-xxs": "14px",
        "font-size-line-height-body-text-xxxl": "30.8px",
        "font-size-line-height-body-text-xxxs": "12.6px",
        "font-size-line-height-body-text-xxxxl": "35px",
        "font-size-line-height-display-text-1": "102.2px",
        "font-size-line-height-display-text-2": "81px",
        "font-size-line-height-display-text-3": "56px",
        "font-size-line-height-heading-text-l": "22.4px",
        "font-size-line-height-heading-text-m": "19.6px",
        "font-size-line-height-heading-text-s": "16.8px",
        "font-size-line-height-heading-text-xl": "25.2px",
        "font-size-line-height-heading-text-xxl": "28px",
        "font-size-line-height-heading-text-xxxl": "30.8px",
        "font-size-line-height-heading-text-xxxxl": "39.2px",
        "font-size-line-height-heading-text-xxxxxl": "81px",
        "font-size-ratio": "1.125",
        "font-size-ratio-major-second": "1.125",
        "font-size-ratio-major-third": "1.25",
        "font-size-ratio-minor-third": "1.2",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "2px",
        "font-space-letter-spacing-m": "1px",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "-1px",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "font-space-word": "normal",
        "font-space-word-l": "2px",
        "font-space-word-m": "normal",
        "font-space-word-s": "1px",
        "font-style-expression": "normal",
        "font-style-expression-italic": "italic",
        "font-style-expression-normal": "normal",
        "font-style-expression-oblique": "oblique",
        "font-style-overflow-wrap": "anywhere",
        "font-style-overflow-wrap-anywhere": "anywhere",
        "font-style-overflow-wrap-break-word": "break-word",
        "font-style-overflow-wrap-normal": "normal",
        "font-style-text-transform": "none",
        "font-style-text-transform-capitalize": "capitalize",
        "font-style-text-transform-lowercase": "lowercase",
        "font-style-text-transform-none": "none",
        "font-style-text-transform-uppercase": "uppercase",
        "font-style-weight-300": "300",
        "font-style-weight-400": "400",
        "font-style-weight-500": "500",
        "font-style-weight-600": "600",
        "font-style-weight-700": "700",
        "font-style-word-break": "break-all",
        "font-style-word-break-break-all": "break-all",
        "font-style-word-break-break-word": "break-word",
        "font-style-word-break-keep-all": "keep-all",
        "font-style-word-break-normal": "normal",
        "shadow-depth-l": "0 8px 12px rgba(0, 0, 0, 0.04), 0 16px 24px rgba(0, 0, 0, 0.08)",
        "shadow-depth-m": "0 2px 4px rgba(0, 0, 0, 0.04), 0 8px 16px rgba(0, 0, 0, 0.08)",
        "shadow-depth-s": "0 2px 2px rgba(0, 0, 0, 0.04), 0 4px 8px rgba(0, 0, 0, 0.08)",
        "shadow-depth-xl": "0 16px 24px rgba(0, 0, 0, 0.04), 0 32px 48px rgba(0, 0, 0, 0.08)",
        "shadow-depth-xs": "0 1px 2px rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.08)",
        "size-action-border-width-focus": "2px",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-border-width-l": "3px",
        "size-border-width-m": "2px",
        "size-border-width-null": "0",
        "size-border-width-s": "1px",
        "size-container-l": "400px",
        "size-container-m": "320px",
        "size-container-null": "0",
        "size-container-s": "240px",
        "size-container-xl": "640px",
        "size-container-xs": "192px",
        "size-container-xxl": "960px",
        "size-container-xxs": "96px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "size-outline-width-l": "3px",
        "size-outline-width-m": "2px",
        "size-outline-width-s": "1px",
        "size-outline-width-xl": "4px",
        "size-zero-state-border-width": "1px",
        "space-base-l": "1.4375rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem",
        "style-action-border-focus": "solid"
    }
};

const EnglishTokens = {
    "name": "english",
    "selectors": [":lang(en)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "font-family-secondary": "'Anova', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "22.4px",
        "font-size-line-height-body-text-m": "19.6px",
        "font-size-line-height-body-text-s": "16.8px",
        "font-size-line-height-body-text-xl": "25.2px",
        "font-size-line-height-body-text-xs": "15.4px",
        "font-size-line-height-body-text-xxl": "28px",
        "font-size-line-height-body-text-xxs": "14px",
        "font-size-line-height-body-text-xxxl": "30.8px",
        "font-size-line-height-body-text-xxxs": "12.6px",
        "font-size-line-height-body-text-xxxxl": "35px",
        "font-size-line-height-display-text-1": "102.2px",
        "font-size-line-height-display-text-2": "81px",
        "font-size-line-height-display-text-3": "56px",
        "font-size-line-height-heading-text-l": "22.4px",
        "font-size-line-height-heading-text-m": "19.6px",
        "font-size-line-height-heading-text-s": "16.8px",
        "font-size-line-height-heading-text-xl": "25.2px",
        "font-size-line-height-heading-text-xxl": "28px",
        "font-size-line-height-heading-text-xxxl": "30.8px",
        "font-size-line-height-heading-text-xxxxl": "39.2px",
        "font-size-line-height-heading-text-xxxxxl": "81px",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.4375rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem"
    }
};

const HebrewTokens = {
    "name": "hebrew",
    "selectors": [":lang(he)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AnovaUI', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'Anova', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "24px",
        "font-size-line-height-body-text-m": "21px",
        "font-size-line-height-body-text-s": "18px",
        "font-size-line-height-body-text-xl": "27px",
        "font-size-line-height-body-text-xs": "16.5px",
        "font-size-line-height-body-text-xxl": "30px",
        "font-size-line-height-body-text-xxs": "15px",
        "font-size-line-height-body-text-xxxl": "33px",
        "font-size-line-height-body-text-xxxs": "13.5px",
        "font-size-line-height-body-text-xxxxl": "37.5px",
        "font-size-line-height-display-text-1": "109.5px",
        "font-size-line-height-display-text-2": "87px",
        "font-size-line-height-display-text-3": "60px",
        "font-size-line-height-heading-text-l": "24px",
        "font-size-line-height-heading-text-m": "21px",
        "font-size-line-height-heading-text-s": "18px",
        "font-size-line-height-heading-text-xl": "27px",
        "font-size-line-height-heading-text-xxl": "30px",
        "font-size-line-height-heading-text-xxxl": "33px",
        "font-size-line-height-heading-text-xxxxl": "42px",
        "font-size-line-height-heading-text-xxxxxl": "87px",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "3rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4rem"
    }
};

const HighContrastTokens = {
    "name": "high-contrast",
    "selectors": ["[data-sas-theme='high-contrast']"],
    "tokens": {
        "brand-color-alert": "hsl(0, 100%, 40%)",
        "brand-color-alert-00": "hsl(0, 0%, 100%)",
        "brand-color-alert-10": "hsl(0, 100%, 98%)",
        "brand-color-alert-100": "hsl(0, 100%, 64%)",
        "brand-color-alert-1000": "hsl(0, 0%, 0%)",
        "brand-color-alert-20": "hsl(0, 100%, 95%)",
        "brand-color-alert-200": "hsl(0, 100%, 59%)",
        "brand-color-alert-30": "hsl(0, 100%, 92%)",
        "brand-color-alert-300": "hsl(0, 100%, 54%)",
        "brand-color-alert-40": "hsl(0, 100%, 88%)",
        "brand-color-alert-400": "hsl(0, 100%, 46%)",
        "brand-color-alert-450": "hsl(0, 100%, 40%)",
        "brand-color-alert-50": "hsl(0, 100%, 84%)",
        "brand-color-alert-500": "hsl(0, 100%, 36%)",
        "brand-color-alert-550": "hsl(0, 100%, 33%)",
        "brand-color-alert-60": "hsl(0, 100%, 79%)",
        "brand-color-alert-600": "hsl(0, 100%, 30%)",
        "brand-color-alert-650": "hsl(0, 100%, 27%)",
        "brand-color-alert-70": "hsl(0, 100%, 76%)",
        "brand-color-alert-700": "hsl(0, 100%, 22%)",
        "brand-color-alert-750": "hsl(0, 100%, 17%)",
        "brand-color-alert-80": "hsl(0, 100%, 72%)",
        "brand-color-alert-800": "hsl(0, 100%, 12%)",
        "brand-color-alert-850": "hsl(0, 100%, 8%)",
        "brand-color-alert-90": "hsl(0, 100%, 68%)",
        "brand-color-alert-900": "hsl(0, 100%, 3%)",
        "brand-color-blue": "hsl(212, 94%, 42%)",
        "brand-color-blue-00": "hsl(212, 0%, 100%)",
        "brand-color-blue-10": "hsl(212, 94%, 97%)",
        "brand-color-blue-100": "hsl(212, 94%, 62%)",
        "brand-color-blue-1000": "hsl(212, 0%, 0%)",
        "brand-color-blue-20": "hsl(212, 94%, 94%)",
        "brand-color-blue-200": "hsl(212, 94%, 57%)",
        "brand-color-blue-30": "hsl(212, 94%, 90%)",
        "brand-color-blue-300": "hsl(212, 94%, 53%)",
        "brand-color-blue-40": "hsl(212, 94%, 88%)",
        "brand-color-blue-400": "hsl(212, 94%, 47%)",
        "brand-color-blue-450": "hsl(212, 94%, 42%)",
        "brand-color-blue-50": "hsl(212, 94%, 83%)",
        "brand-color-blue-500": "hsl(212, 94%, 36%)",
        "brand-color-blue-550": "hsl(212, 94%, 35%)",
        "brand-color-blue-60": "hsl(212, 94%, 78%)",
        "brand-color-blue-600": "hsl(212, 94%, 31%)",
        "brand-color-blue-650": "hsl(212, 94%, 27%)",
        "brand-color-blue-70": "hsl(212, 94%, 76%)",
        "brand-color-blue-700": "hsl(212, 94%, 23%)",
        "brand-color-blue-750": "hsl(212, 94%, 17%)",
        "brand-color-blue-80": "hsl(212, 94%, 72%)",
        "brand-color-blue-800": "hsl(212, 94%, 12%)",
        "brand-color-blue-850": "hsl(212, 94%, 8%)",
        "brand-color-blue-90": "hsl(212, 94%, 68%)",
        "brand-color-blue-900": "hsl(212, 94%, 3%)",
        "brand-color-cranberry": "hsl(329, 60%, 40%)",
        "brand-color-cranberry-00": "hsl(329,60%,100%)",
        "brand-color-cranberry-10": "hsl(329,60%,98%)",
        "brand-color-cranberry-100": "hsl(329,60%,62%)",
        "brand-color-cranberry-1000": "hsl(329,60%,0%)",
        "brand-color-cranberry-20": "hsl(329,60%,97%)",
        "brand-color-cranberry-200": "hsl(329,60%,57%)",
        "brand-color-cranberry-30": "hsl(329,60%,92%)",
        "brand-color-cranberry-300": "hsl(329,60%,55%)",
        "brand-color-cranberry-40": "hsl(329,60%,88%)",
        "brand-color-cranberry-400": "hsl(329,60%,52%)",
        "brand-color-cranberry-450": "hsl(329,60%,40%)",
        "brand-color-cranberry-50": "hsl(329,60%,84%)",
        "brand-color-cranberry-500": "hsl(329,60%,37%)",
        "brand-color-cranberry-550": "hsl(329,60%,32%)",
        "brand-color-cranberry-60": "hsl(329,60%,78%)",
        "brand-color-cranberry-600": "hsl(329,60%,30%)",
        "brand-color-cranberry-650": "hsl(329,60%,27%)",
        "brand-color-cranberry-70": "hsl(329,60%,76%)",
        "brand-color-cranberry-700": "hsl(329,60%,22%)",
        "brand-color-cranberry-750": "hsl(329,60%,16%)",
        "brand-color-cranberry-80": "hsl(329,60%,72%)",
        "brand-color-cranberry-800": "hsl(329,60%,11%)",
        "brand-color-cranberry-850": "hsl(329,60%,9%)",
        "brand-color-cranberry-90": "hsl(329,60%,68%)",
        "brand-color-cranberry-900": "hsl(329,60%,4%)",
        "brand-color-grey": "hsl(219, 12%, 42%)",
        "brand-color-grey-00": "hsl(219, 0%, 100%)",
        "brand-color-grey-10": "hsl(219, 12%, 98%)",
        "brand-color-grey-100": "hsl(219, 12%, 64%)",
        "brand-color-grey-1000": "hsl(219, 0%, 0%)",
        "brand-color-grey-20": "hsl(219, 12%, 96%)",
        "brand-color-grey-200": "hsl(219, 12%, 59%)",
        "brand-color-grey-30": "hsl(219, 12%, 92%)",
        "brand-color-grey-300": "hsl(219, 12%, 55%)",
        "brand-color-grey-40": "hsl(219, 12%, 88%)",
        "brand-color-grey-400": "hsl(219, 12%, 48%)",
        "brand-color-grey-450": "hsl(219, 12%, 42%)",
        "brand-color-grey-50": "hsl(219, 12%, 84%)",
        "brand-color-grey-500": "hsl(219, 12%, 36%)",
        "brand-color-grey-550": "hsl(219, 12%, 33%)",
        "brand-color-grey-60": "hsl(219, 12%, 79%)",
        "brand-color-grey-600": "hsl(219, 12%, 30%)",
        "brand-color-grey-650": "hsl(219, 12%, 27%)",
        "brand-color-grey-70": "hsl(219, 12%, 76%)",
        "brand-color-grey-700": "hsl(219, 12%, 22%)",
        "brand-color-grey-750": "hsl(219, 12%, 17%)",
        "brand-color-grey-80": "hsl(219, 12%, 72%)",
        "brand-color-grey-800": "hsl(219, 12%, 12%)",
        "brand-color-grey-850": "hsl(219, 12%, 8%)",
        "brand-color-grey-90": "hsl(219, 12%, 68%)",
        "brand-color-grey-900": "hsl(219, 12%, 3%)",
        "brand-color-info": "hsl(212, 94%, 42%)",
        "brand-color-info-00": "hsl(212, 0%, 100%)",
        "brand-color-info-10": "hsl(212, 94%, 97%)",
        "brand-color-info-100": "hsl(212, 94%, 62%)",
        "brand-color-info-1000": "hsl(212, 0%, 0%)",
        "brand-color-info-20": "hsl(212, 94%, 94%)",
        "brand-color-info-200": "hsl(212, 94%, 57%)",
        "brand-color-info-30": "hsl(212, 94%, 90%)",
        "brand-color-info-300": "hsl(212, 94%, 53%)",
        "brand-color-info-40": "hsl(212, 94%, 88%)",
        "brand-color-info-400": "hsl(212, 94%, 47%)",
        "brand-color-info-450": "hsl(212, 94%, 42%)",
        "brand-color-info-50": "hsl(212, 94%, 83%)",
        "brand-color-info-500": "hsl(212, 94%, 36%)",
        "brand-color-info-550": "hsl(212, 94%, 35%)",
        "brand-color-info-60": "hsl(212, 94%, 78%)",
        "brand-color-info-600": "hsl(212, 94%, 31%)",
        "brand-color-info-650": "hsl(212, 94%, 27%)",
        "brand-color-info-70": "hsl(212, 94%, 76%)",
        "brand-color-info-700": "hsl(212, 94%, 23%)",
        "brand-color-info-750": "hsl(212, 94%, 17%)",
        "brand-color-info-80": "hsl(212, 94%, 72%)",
        "brand-color-info-800": "hsl(212, 94%, 12%)",
        "brand-color-info-850": "hsl(212, 94%, 8%)",
        "brand-color-info-90": "hsl(212, 94%, 68%)",
        "brand-color-info-900": "hsl(212, 94%, 3%)",
        "brand-color-success": "hsl(123, 46%, 43%)",
        "brand-color-success-00": "hsl(123, 0%, 100%)",
        "brand-color-success-10": "hsl(123, 46%, 98%)",
        "brand-color-success-100": "hsl(123, 46%, 63%)",
        "brand-color-success-1000": "hsl(123, 0%, 0%)",
        "brand-color-success-20": "hsl(123, 46%, 95%)",
        "brand-color-success-200": "hsl(123, 46%, 58%)",
        "brand-color-success-30": "hsl(123, 46%, 90%)",
        "brand-color-success-300": "hsl(123, 46%, 55%)",
        "brand-color-success-40": "hsl(123, 46%, 87%)",
        "brand-color-success-400": "hsl(123, 46%, 48%)",
        "brand-color-success-450": "hsl(123, 46%, 43%)",
        "brand-color-success-50": "hsl(123, 46%, 82%)",
        "brand-color-success-500": "hsl(123, 46%, 36%)",
        "brand-color-success-550": "hsl(123, 46%, 34%)",
        "brand-color-success-60": "hsl(123, 46%, 78%)",
        "brand-color-success-600": "hsl(123, 46%, 30%)",
        "brand-color-success-650": "hsl(123, 46%, 25%)",
        "brand-color-success-70": "hsl(123, 46%, 75%)",
        "brand-color-success-700": "hsl(123, 46%, 22%)",
        "brand-color-success-750": "hsl(123, 46%, 17%)",
        "brand-color-success-80": "hsl(123, 46%, 70%)",
        "brand-color-success-800": "hsl(123, 46%, 12%)",
        "brand-color-success-850": "hsl(123, 46%, 8%)",
        "brand-color-success-90": "hsl(123, 46%, 66%)",
        "brand-color-success-900": "hsl(123, 46%, 3%)",
        "brand-color-warning": "hsl(43, 89%, 44%)",
        "brand-color-warning-00": "hsl(43, 0%, 100%)",
        "brand-color-warning-10": "hsl(43, 89%, 98%)",
        "brand-color-warning-100": "hsl(43, 89%, 64%)",
        "brand-color-warning-1000": "hsl(43, 0%, 0%)",
        "brand-color-warning-20": "hsl(43, 89%, 95%)",
        "brand-color-warning-200": "hsl(43, 89%, 60%)",
        "brand-color-warning-30": "hsl(43, 89%, 92%)",
        "brand-color-warning-300": "hsl(43, 89%, 56%)",
        "brand-color-warning-40": "hsl(43, 89%, 88%)",
        "brand-color-warning-400": "hsl(43, 89%, 52%)",
        "brand-color-warning-450": "hsl(43, 89%, 44%)",
        "brand-color-warning-50": "hsl(43, 89%, 84%)",
        "brand-color-warning-500": "hsl(43, 89%, 39%)",
        "brand-color-warning-550": "hsl(43, 89%, 35%)",
        "brand-color-warning-60": "hsl(43, 89%, 79%)",
        "brand-color-warning-600": "hsl(43, 89%, 31%)",
        "brand-color-warning-650": "hsl(43, 89%, 27%)",
        "brand-color-warning-70": "hsl(43, 89%, 76%)",
        "brand-color-warning-700": "hsl(43, 89%, 24%)",
        "brand-color-warning-750": "hsl(43, 89%, 17%)",
        "brand-color-warning-80": "hsl(43, 89%, 72%)",
        "brand-color-warning-800": "hsl(43, 89%, 12%)",
        "brand-color-warning-850": "hsl(43, 89%, 8%)",
        "brand-color-warning-90": "hsl(43, 89%, 68%)",
        "brand-color-warning-900": "hsl(43, 89%, 3%)",
        "color-action-background-control-alert": "hsl(0, 0%, 0%)",
        "color-action-background-control-disabled": "hsl(219, 0%, 0%)",
        "color-action-background-control-hover": "hsl(219, 12%, 30%)",
        "color-action-background-control-normal": "hsl(219, 0%, 0%)",
        "color-action-background-control-primary": "hsl(219, 0%, 100%)",
        "color-action-background-control-read-only": "hsl(219, 0%, 0%)",
        "color-action-background-control-selected": "hsl(212, 94%, 17%)",
        "color-action-background-control-warning": "hsl(43, 0%, 0%)",
        "color-action-background-emphasis-active": "hsl(212, 94%, 83%)",
        "color-action-background-emphasis-disabled": "hsl(219, 0%, 0%)",
        "color-action-background-emphasis-hover": "hsl(212, 94%, 31%)",
        "color-action-background-emphasis-normal": "hsl(212, 0%, 0%)",
        "color-action-background-emphasis-selected": "hsl(212, 94%, 83%)",
        "color-action-background-emphasis-visited": "hsl(212, 0%, 0%)",
        "color-action-background-focus": "hsl(205, 97%, 76%)",
        "color-action-background-focus-inverse": "hsl(0, 0%, 0%)",
        "color-action-background-on-off-disabled": "hsl(219, 0%, 0%)",
        "color-action-background-on-off-hover": "hsl(219, 12%, 30%)",
        "color-action-background-on-off-normal": "hsl(219, 0%, 0%)",
        "color-action-background-on-off-read-only": "hsl(219, 0%, 0%)",
        "color-action-background-on-off-selected": "hsl(212, 0%, 100%)",
        "color-action-background-on-off-selected-disabled": "hsl(219, 12%, 17%)",
        "color-action-background-standard-active": "hsl(212, 0%, 100%)",
        "color-action-background-standard-disabled": "hsl(219, 0%, 0%)",
        "color-action-background-standard-hover": "hsl(219, 12%, 30%)",
        "color-action-background-standard-normal": "hsl(219, 0%, 0%)",
        "color-action-background-standard-selected": "hsl(212, 0%, 100%)",
        "color-action-background-standard-selected-disabled": "hsl(219, 12%, 17%)",
        "color-action-background-standard-selected-inactive": "hsl(219, 12%, 30%)",
        "color-action-background-standard-visited": "hsl(219, 0%, 0%)",
        "color-action-background-subtle-disabled": "hsla(0, 0%, 0%, 0)",
        "color-action-background-subtle-hover": "hsl(219, 12%, 30%)",
        "color-action-background-subtle-normal": "hsla(0, 0%, 0%, 0)",
        "color-action-background-subtle-selected": "hsl(212, 0%, 100%)",
        "color-action-background-subtle-selected-disabled": "hsl(219, 12%, 17%)",
        "color-action-background-subtle-selected-inactive": "hsl(219, 12%, 30%)",
        "color-action-border-bottom-control-alert": "hsl(0, 100%, 84%)",
        "color-action-border-bottom-control-hover": "hsl(219, 0%, 100%)",
        "color-action-border-bottom-control-normal": "hsl(219, 0%, 100%)",
        "color-action-border-bottom-control-selected": "hsl(212, 94%, 83%)",
        "color-action-border-bottom-control-warning": "hsl(43, 89%, 84%)",
        "color-action-border-control-alert": "hsl(0, 0%, 0%)",
        "color-action-border-control-disabled": "hsl(219, 0%, 0%)",
        "color-action-border-control-hover": "hsl(219, 0%, 100%)",
        "color-action-border-control-normal": "hsl(219, 0%, 100%)",
        "color-action-border-control-read-only": "hsl(219, 0%, 0%)",
        "color-action-border-control-selected": "hsl(212, 94%, 17%)",
        "color-action-border-control-warning": "hsl(43, 89%, 84%)",
        "color-action-border-emphasis-active": "hsl(212, 94%, 83%)",
        "color-action-border-emphasis-disabled": "hsl(219, 0%, 0%)",
        "color-action-border-emphasis-hover": "hsl(212, 0%, 100%)",
        "color-action-border-emphasis-normal": "hsl(212, 94%, 83%)",
        "color-action-border-emphasis-selected": "hsl(212, 94%, 83%)",
        "color-action-border-emphasis-visited": "hsl(212, 94%, 83%)",
        "color-action-border-focus": "hsl(212, 94%, 83%)",
        "color-action-border-focus-inverse": "hsl(212, 0%, 0%)",
        "color-action-border-on-off-disabled": "hsl(219, 12%, 22%)",
        "color-action-border-on-off-hover": "hsl(219, 0%, 100%)",
        "color-action-border-on-off-normal": "hsl(219, 0%, 100%)",
        "color-action-border-on-off-read-only": "hsl(219, 0%, 100%)",
        "color-action-border-on-off-selected": "hsl(212, 0%, 100%)",
        "color-action-border-on-off-selected-disabled": "hsl(219, 12%, 17%)",
        "color-action-border-standard-active": "hsl(212, 0%, 100%)",
        "color-action-border-standard-disabled": "hsl(219, 0%, 0%)",
        "color-action-border-standard-hover": "hsl(219, 0%, 100%)",
        "color-action-border-standard-normal": "hsl(219, 0%, 100%)",
        "color-action-border-standard-selected": "hsl(212, 0%, 100%)",
        "color-action-border-standard-selected-disabled": "hsl(219, 12%, 17%)",
        "color-action-border-standard-selected-inactive": "hsl(219, 12%, 30%)",
        "color-action-border-standard-visited": "hsl(219, 0%, 100%)",
        "color-action-border-subtle-disabled": "hsla(0, 0%, 0%, 0)",
        "color-action-border-subtle-hover": "hsl(219, 12%, 30%)",
        "color-action-border-subtle-normal": "hsla(0, 0%, 0%, 0)",
        "color-action-border-subtle-selected": "hsl(212, 0%, 100%)",
        "color-action-border-subtle-selected-disabled": "hsl(219, 12%, 17%)",
        "color-action-border-subtle-selected-inactive": "hsl(219, 12%, 30%)",
        "color-action-focus": "hsl(212, 94%, 83%)",
        "color-action-icon-control-alert": "hsl(0, 0%, 100%)",
        "color-action-icon-control-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-control-hover": "hsl(219, 0%, 100%)",
        "color-action-icon-control-normal": "hsl(219, 0%, 100%)",
        "color-action-icon-control-read-only": "hsl(219, 0%, 100%)",
        "color-action-icon-control-selected": "hsl(212, 0%, 100%)",
        "color-action-icon-control-warning": "hsl(43, 0%, 100%)",
        "color-action-icon-emphasis-active": "hsl(212, 0%, 0%)",
        "color-action-icon-emphasis-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-emphasis-hover": "hsl(212, 0%, 100%)",
        "color-action-icon-emphasis-normal": "hsl(212, 94%, 83%)",
        "color-action-icon-emphasis-selected": "hsl(212, 0%, 0%)",
        "color-action-icon-emphasis-visited": "hsl(212, 94%, 83%)",
        "color-action-icon-on-off-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-on-off-hover": "hsl(219, 0%, 100%)",
        "color-action-icon-on-off-normal": "hsl(219, 0%, 100%)",
        "color-action-icon-on-off-read-only": "hsl(219, 0%, 100%)",
        "color-action-icon-on-off-selected": "hsl(212, 0%, 0%)",
        "color-action-icon-on-off-selected-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-standard-active": "hsl(212, 0%, 0%)",
        "color-action-icon-standard-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-standard-hover": "hsl(219, 0%, 100%)",
        "color-action-icon-standard-normal": "hsl(219, 0%, 100%)",
        "color-action-icon-standard-selected": "hsl(212, 0%, 0%)",
        "color-action-icon-standard-selected-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-standard-selected-inactive": "hsl(219, 0%, 100%)",
        "color-action-icon-standard-visited": "hsl(219, 0%, 100%)",
        "color-action-icon-subtle-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-subtle-hover": "hsl(219, 0%, 100%)",
        "color-action-icon-subtle-normal": "hsl(219, 0%, 100%)",
        "color-action-icon-subtle-selected": "hsl(212, 0%, 0%)",
        "color-action-icon-subtle-selected-disabled": "hsl(219, 12%, 30%)",
        "color-action-icon-subtle-selected-inactive": "hsl(219, 0%, 100%)",
        "color-action-link-active": "hsl(219, 0%, 100%)",
        "color-action-link-hover": "hsl(212, 94%, 83%)",
        "color-action-link-normal": "hsl(212, 94%, 83%)",
        "color-action-link-visited": "hsl(212, 94%, 83%)",
        "color-action-text-control-alert": "hsl(0, 0%, 100%)",
        "color-action-text-control-disabled": "hsl(219, 12%, 30%)",
        "color-action-text-control-hover": "hsl(219, 0%, 100%)",
        "color-action-text-control-normal": "hsl(219, 0%, 100%)",
        "color-action-text-control-placeholder": "hsl(219, 0%, 100%)",
        "color-action-text-control-read-only": "hsl(219, 0%, 100%)",
        "color-action-text-control-selected": "hsl(212, 0%, 100%)",
        "color-action-text-control-warning": "hsl(43, 0%, 100%)",
        "color-action-text-emphasis-active": "hsl(212, 0%, 0%)",
        "color-action-text-emphasis-disabled": "hsl(219, 12%, 36%)",
        "color-action-text-emphasis-hover": "hsl(212, 0%, 100%)",
        "color-action-text-emphasis-normal": "hsl(212, 94%, 83%)",
        "color-action-text-emphasis-selected": "hsl(212, 0%, 0%)",
        "color-action-text-emphasis-visited": "hsl(212, 94%, 83%)",
        "color-action-text-on-off-disabled": "hsl(219, 12%, 30%)",
        "color-action-text-on-off-hover": "hsl(219, 0%, 100%)",
        "color-action-text-on-off-normal": "hsl(219, 0%, 100%)",
        "color-action-text-on-off-read-only": "hsl(219, 0%, 100%)",
        "color-action-text-on-off-selected": "hsl(212, 0%, 0%)",
        "color-action-text-on-off-selected-disabled": "hsl(219, 12%, 79%)",
        "color-action-text-standard-active": "hsl(212, 0%, 0%)",
        "color-action-text-standard-disabled": "hsl(219, 12%, 30%)",
        "color-action-text-standard-hover": "hsl(219, 0%, 100%)",
        "color-action-text-standard-normal": "hsl(219, 0%, 100%)",
        "color-action-text-standard-selected": "hsl(212, 0%, 0%)",
        "color-action-text-standard-selected-disabled": "hsl(219, 12%, 30%)",
        "color-action-text-standard-selected-inactive": "hsl(219, 0%, 100%)",
        "color-action-text-standard-visited": "hsl(219, 0%, 100%)",
        "color-action-text-subtle-disabled": "hsl(219, 12%, 30%)",
        "color-action-text-subtle-hover": "hsl(219, 0%, 100%)",
        "color-action-text-subtle-normal": "hsl(219, 0%, 100%)",
        "color-action-text-subtle-selected": "hsl(212, 0%, 0%)",
        "color-action-text-subtle-selected-disabled": "hsl(219, 12%, 30%)",
        "color-action-text-subtle-selected-inactive": "hsl(219, 0%, 100%)",
        "color-alert-00": "hsl(0, 0%, 100%)",
        "color-alert-10": "hsl(0, 100%, 98%)",
        "color-alert-100": "hsl(0, 100%, 64%)",
        "color-alert-1000": "hsl(0, 0%, 0%)",
        "color-alert-20": "hsl(0, 100%, 95%)",
        "color-alert-200": "hsl(0, 100%, 59%)",
        "color-alert-30": "hsl(0, 100%, 92%)",
        "color-alert-300": "hsl(0, 100%, 54%)",
        "color-alert-40": "hsl(0, 100%, 88%)",
        "color-alert-400": "hsl(0, 100%, 46%)",
        "color-alert-450": "hsl(0, 100%, 40%)",
        "color-alert-50": "hsl(0, 100%, 84%)",
        "color-alert-500": "hsl(0, 100%, 36%)",
        "color-alert-550": "hsl(0, 100%, 33%)",
        "color-alert-60": "hsl(0, 100%, 79%)",
        "color-alert-600": "hsl(0, 100%, 30%)",
        "color-alert-650": "hsl(0, 100%, 27%)",
        "color-alert-70": "hsl(0, 100%, 76%)",
        "color-alert-700": "hsl(0, 100%, 22%)",
        "color-alert-750": "hsl(0, 100%, 17%)",
        "color-alert-80": "hsl(0, 100%, 72%)",
        "color-alert-800": "hsl(0, 100%, 12%)",
        "color-alert-850": "hsl(0, 100%, 8%)",
        "color-alert-90": "hsl(0, 100%, 68%)",
        "color-alert-900": "hsl(0, 100%, 3%)",
        "color-body-icon": "hsl(219, 0%, 100%)",
        "color-body-text": "hsl(219, 0%, 100%)",
        "color-container-background-0": "hsl(219, 0%, 0%)",
        "color-container-background-1": "hsl(219, 0%, 0%)",
        "color-container-background-2": "hsl(219, 0%, 0%)",
        "color-container-background-3": "hsl(212, 94%, 35%)",
        "color-container-background-4": "hsl(219, 0%, 100%)",
        "color-container-border-4": "hsl(219, 0%, 100%)",
        "color-dataviz-graph-alt1": "#8AC9FF",
        "color-dataviz-graph-alt2": "#FCE759",
        "color-dataviz-graph-alt3": "#E4C7FF",
        "color-dataviz-graph-alt4": "#FBB074",
        "color-dataviz-graph-alt5": "#76FABA",
        "color-dataviz-graph-alt6": "#F5BEBA",
        "color-dataviz-graph-alt7": "#B6F64E",
        "color-dataviz-graph-alt8": "#FFADDA",
        "color-dataviz-graph1": "#4AACFF",
        "color-dataviz-graph2": "#F1D700",
        "color-dataviz-graph3": "#C68AFF",
        "color-dataviz-graph4": "#F98E39",
        "color-dataviz-graph5": "#00D692",
        "color-dataviz-graph6": "#FF817A",
        "color-dataviz-graph7": "#7CBF00",
        "color-dataviz-graph8": "#FF6FBD",
        "color-dataviz-kpi-alt1": "#FF928A",
        "color-dataviz-kpi-alt3": "#F6E583",
        "color-dataviz-kpi-alt5": "#9AC473",
        "color-dataviz-kpi1": "#ff5e4d",
        "color-dataviz-kpi3": "#f2d94b",
        "color-dataviz-kpi5": "#7bb04a",
        "color-display-icon": "hsl(219, 0%, 100%)",
        "color-display-text": "hsl(219, 0%, 100%)",
        "color-heading-icon": "hsl(219, 0%, 100%)",
        "color-heading-text": "hsl(219, 0%, 100%)",
        "color-highlight-text": "hsl(212, 94%, 83%)",
        "color-highlight-text-inverse": "hsl(212, 0%, 0%)",
        "color-icon-neutral": "hsl(212, 0%, 100%)",
        "color-icon-primary": "hsl(212, 94%, 83%)",
        "color-icon-secondary": "hsl(329,60%,62%)",
        "color-info-00": "hsl(212, 0%, 100%)",
        "color-info-10": "hsl(212, 94%, 97%)",
        "color-info-100": "hsl(212, 94%, 62%)",
        "color-info-1000": "hsl(212, 0%, 0%)",
        "color-info-20": "hsl(212, 94%, 94%)",
        "color-info-200": "hsl(212, 94%, 57%)",
        "color-info-30": "hsl(212, 94%, 90%)",
        "color-info-300": "hsl(212, 94%, 53%)",
        "color-info-40": "hsl(212, 94%, 88%)",
        "color-info-400": "hsl(212, 94%, 47%)",
        "color-info-450": "hsl(212, 94%, 42%)",
        "color-info-50": "hsl(212, 94%, 83%)",
        "color-info-500": "hsl(212, 94%, 36%)",
        "color-info-550": "hsl(212, 94%, 35%)",
        "color-info-60": "hsl(212, 94%, 78%)",
        "color-info-600": "hsl(212, 94%, 31%)",
        "color-info-650": "hsl(212, 94%, 27%)",
        "color-info-70": "hsl(212, 94%, 76%)",
        "color-info-700": "hsl(212, 94%, 23%)",
        "color-info-750": "hsl(212, 94%, 17%)",
        "color-info-80": "hsl(212, 94%, 72%)",
        "color-info-800": "hsl(212, 94%, 12%)",
        "color-info-850": "hsl(212, 94%, 8%)",
        "color-info-90": "hsl(212, 94%, 68%)",
        "color-info-900": "hsl(212, 94%, 3%)",
        "color-label-text": "hsl(219, 0%, 100%)",
        "color-neutral": "hsl(219, 12%, 84%)",
        "color-neutral-00": "hsl(219, 0%, 100%)",
        "color-neutral-10": "hsl(219, 12%, 98%)",
        "color-neutral-100": "hsl(219, 12%, 64%)",
        "color-neutral-1000": "hsl(219, 0%, 0%)",
        "color-neutral-20": "hsl(219, 12%, 96%)",
        "color-neutral-200": "hsl(219, 12%, 59%)",
        "color-neutral-30": "hsl(219, 12%, 92%)",
        "color-neutral-300": "hsl(219, 12%, 55%)",
        "color-neutral-40": "hsl(219, 12%, 88%)",
        "color-neutral-400": "hsl(219, 12%, 48%)",
        "color-neutral-450": "hsl(219, 12%, 42%)",
        "color-neutral-50": "hsl(219, 12%, 84%)",
        "color-neutral-500": "hsl(219, 12%, 36%)",
        "color-neutral-550": "hsl(219, 12%, 33%)",
        "color-neutral-60": "hsl(219, 12%, 79%)",
        "color-neutral-600": "hsl(219, 12%, 30%)",
        "color-neutral-650": "hsl(219, 12%, 27%)",
        "color-neutral-70": "hsl(219, 12%, 76%)",
        "color-neutral-700": "hsl(219, 12%, 22%)",
        "color-neutral-750": "hsl(219, 12%, 17%)",
        "color-neutral-80": "hsl(219, 12%, 72%)",
        "color-neutral-800": "hsl(219, 12%, 12%)",
        "color-neutral-850": "hsl(219, 12%, 8%)",
        "color-neutral-90": "hsl(219, 12%, 68%)",
        "color-neutral-900": "hsl(219, 12%, 3%)",
        "color-primary": "hsl(212, 94%, 83%)",
        "color-primary-00": "hsl(212, 0%, 100%)",
        "color-primary-10": "hsl(212, 94%, 97%)",
        "color-primary-100": "hsl(212, 94%, 62%)",
        "color-primary-1000": "hsl(212, 0%, 0%)",
        "color-primary-20": "hsl(212, 94%, 94%)",
        "color-primary-200": "hsl(212, 94%, 57%)",
        "color-primary-30": "hsl(212, 94%, 90%)",
        "color-primary-300": "hsl(212, 94%, 53%)",
        "color-primary-40": "hsl(212, 94%, 88%)",
        "color-primary-400": "hsl(212, 94%, 47%)",
        "color-primary-450": "hsl(212, 94%, 42%)",
        "color-primary-50": "hsl(212, 94%, 83%)",
        "color-primary-500": "hsl(212, 94%, 36%)",
        "color-primary-550": "hsl(212, 94%, 35%)",
        "color-primary-60": "hsl(212, 94%, 78%)",
        "color-primary-600": "hsl(212, 94%, 31%)",
        "color-primary-650": "hsl(212, 94%, 27%)",
        "color-primary-70": "hsl(212, 94%, 76%)",
        "color-primary-700": "hsl(212, 94%, 23%)",
        "color-primary-750": "hsl(212, 94%, 17%)",
        "color-primary-80": "hsl(212, 94%, 72%)",
        "color-primary-800": "hsl(212, 94%, 12%)",
        "color-primary-850": "hsl(212, 94%, 8%)",
        "color-primary-90": "hsl(212, 94%, 68%)",
        "color-primary-900": "hsl(212, 94%, 3%)",
        "color-secondary": "hsl(329,60%,57%)",
        "color-secondary-00": "hsl(329,60%,100%)",
        "color-secondary-10": "hsl(329,60%,98%)",
        "color-secondary-100": "hsl(329,60%,62%)",
        "color-secondary-1000": "hsl(329,60%,0%)",
        "color-secondary-20": "hsl(329,60%,97%)",
        "color-secondary-200": "hsl(329,60%,57%)",
        "color-secondary-30": "hsl(329,60%,92%)",
        "color-secondary-300": "hsl(329,60%,55%)",
        "color-secondary-40": "hsl(329,60%,88%)",
        "color-secondary-400": "hsl(329,60%,52%)",
        "color-secondary-450": "hsl(329,60%,40%)",
        "color-secondary-50": "hsl(329,60%,84%)",
        "color-secondary-500": "hsl(329,60%,37%)",
        "color-secondary-550": "hsl(329,60%,32%)",
        "color-secondary-60": "hsl(329,60%,78%)",
        "color-secondary-600": "hsl(329,60%,30%)",
        "color-secondary-650": "hsl(329,60%,27%)",
        "color-secondary-70": "hsl(329,60%,76%)",
        "color-secondary-700": "hsl(329,60%,22%)",
        "color-secondary-750": "hsl(329,60%,16%)",
        "color-secondary-80": "hsl(329,60%,72%)",
        "color-secondary-800": "hsl(329,60%,11%)",
        "color-secondary-850": "hsl(329,60%,9%)",
        "color-secondary-90": "hsl(329,60%,68%)",
        "color-secondary-900": "hsl(329,60%,4%)",
        "color-status-alert": "hsl(0, 100%, 84%)",
        "color-status-background-alert": "hsl(0, 0%, 0%)",
        "color-status-background-info": "hsl(212, 0%, 0%)",
        "color-status-background-neutral": "hsl(219, 0%, 0%)",
        "color-status-background-success": "hsl(123, 0%, 0%)",
        "color-status-background-warning": "hsl(43, 0%, 0%)",
        "color-status-border-alert": "hsl(0, 100%, 84%)",
        "color-status-border-info": "hsl(212, 94%, 83%)",
        "color-status-border-neutral": "hsl(219, 12%, 84%)",
        "color-status-border-success": "hsl(123, 46%, 82%)",
        "color-status-border-warning": "hsl(43, 89%, 84%)",
        "color-status-icon-alert": "hsl(0, 100%, 84%)",
        "color-status-icon-info": "hsl(212, 94%, 83%)",
        "color-status-icon-neutral": "hsl(219, 12%, 84%)",
        "color-status-icon-success": "hsl(123, 46%, 82%)",
        "color-status-icon-warning": "hsl(43, 89%, 84%)",
        "color-status-info": "hsl(212, 94%, 83%)",
        "color-status-neutral": "hsl(219, 12%, 84%)",
        "color-status-success": "hsl(123, 46%, 82%)",
        "color-status-text-alert": "hsl(0, 100%, 84%)",
        "color-status-text-info": "hsl(212, 94%, 83%)",
        "color-status-text-neutral": "hsl(219, 12%, 84%)",
        "color-status-text-success": "hsl(123, 46%, 82%)",
        "color-status-text-warning": "hsl(43, 89%, 84%)",
        "color-status-warning": "hsl(43, 89%, 84%)",
        "color-success-00": "hsl(123, 0%, 100%)",
        "color-success-10": "hsl(123, 46%, 98%)",
        "color-success-100": "hsl(123, 46%, 63%)",
        "color-success-1000": "hsl(123, 0%, 0%)",
        "color-success-20": "hsl(123, 46%, 95%)",
        "color-success-200": "hsl(123, 46%, 58%)",
        "color-success-30": "hsl(123, 46%, 90%)",
        "color-success-300": "hsl(123, 46%, 55%)",
        "color-success-40": "hsl(123, 46%, 87%)",
        "color-success-400": "hsl(123, 46%, 48%)",
        "color-success-450": "hsl(123, 46%, 43%)",
        "color-success-50": "hsl(123, 46%, 82%)",
        "color-success-500": "hsl(123, 46%, 36%)",
        "color-success-550": "hsl(123, 46%, 34%)",
        "color-success-60": "hsl(123, 46%, 78%)",
        "color-success-600": "hsl(123, 46%, 30%)",
        "color-success-650": "hsl(123, 46%, 25%)",
        "color-success-70": "hsl(123, 46%, 75%)",
        "color-success-700": "hsl(123, 46%, 22%)",
        "color-success-750": "hsl(123, 46%, 17%)",
        "color-success-80": "hsl(123, 46%, 70%)",
        "color-success-800": "hsl(123, 46%, 12%)",
        "color-success-850": "hsl(123, 46%, 8%)",
        "color-success-90": "hsl(123, 46%, 66%)",
        "color-success-900": "hsl(123, 46%, 3%)",
        "color-syntax-text-01": "#FFFFFF",
        "color-syntax-text-02": "#D6C539",
        "color-syntax-text-03": "#F98E39",
        "color-syntax-text-04": "#FF7973",
        "color-syntax-text-05": "#FF6FBD",
        "color-syntax-text-06": "#C68AFF",
        "color-syntax-text-07": "#61A8FA",
        "color-syntax-text-08": "#1FBBA9",
        "color-syntax-text-09": "#87B532",
        "color-syntax-text-attribute-name": "#61A8FA",
        "color-syntax-text-attribute-value": "#FF7973",
        "color-syntax-text-boolean": "#FF6FBD",
        "color-syntax-text-character-constant": "#1FBBA9",
        "color-syntax-text-class-name": "#1FBBA9",
        "color-syntax-text-comment": "#87B532",
        "color-syntax-text-control": "#FF6FBD",
        "color-syntax-text-data": "#F98E39",
        "color-syntax-text-declaration": "#C68AFF",
        "color-syntax-text-default": "#FFFFFF",
        "color-syntax-text-function": "#FF6FBD",
        "color-syntax-text-identifier": "#FFFFFF",
        "color-syntax-text-keyword": "#C68AFF",
        "color-syntax-text-namespace": "#1FBBA9",
        "color-syntax-text-normal": "#FFFFFF",
        "color-syntax-text-numeric-constant": "#1FBBA9",
        "color-syntax-text-operator": "#61A8FA",
        "color-syntax-text-proc-name": "#61A8FA",
        "color-syntax-text-property": "#C68AFF",
        "color-syntax-text-punctuation": "#D6C539",
        "color-syntax-text-punctuation-brackets": "#D6C539",
        "color-syntax-text-section": "#61A8FA",
        "color-syntax-text-separator": "#FFFFFF",
        "color-syntax-text-source": "#C68AFF",
        "color-syntax-text-storage-type": "#C68AFF",
        "color-syntax-text-string": "#FF7973",
        "color-syntax-text-tag": "#C68AFF",
        "color-syntax-text-variable": "#61A8FA",
        "color-tag-background-1": "hsl(212, 94%, 31%)",
        "color-tag-background-2": "hsl(329,60%,30%)",
        "color-tag-background-3": "hsl(219, 12%, 30%)",
        "color-tag-border-1": "hsl(212, 94%, 97%)",
        "color-tag-border-2": "hsl(329,60%,98%)",
        "color-tag-border-3": "hsl(219, 12%, 98%)",
        "color-text-neutral": "hsl(219, 0%, 100%)",
        "color-text-neutral-inverse": "hsl(219, 0%, 0%)",
        "color-text-primary": "hsl(212, 94%, 83%)",
        "color-text-primary-inverse": "hsl(212, 0%, 100%)",
        "color-text-secondary": "hsl(329,60%,62%)",
        "color-thumbnail-fill-1": "hsl(212, 94%, 97%)",
        "color-thumbnail-fill-2": "hsl(212, 94%, 90%)",
        "color-thumbnail-fill-3": "hsl(212, 94%, 78%)",
        "color-thumbnail-fill-4": "hsl(212, 94%, 62%)",
        "color-warning-00": "hsl(43, 0%, 100%)",
        "color-warning-10": "hsl(43, 89%, 98%)",
        "color-warning-100": "hsl(43, 89%, 64%)",
        "color-warning-1000": "hsl(43, 0%, 0%)",
        "color-warning-20": "hsl(43, 89%, 95%)",
        "color-warning-200": "hsl(43, 89%, 60%)",
        "color-warning-30": "hsl(43, 89%, 92%)",
        "color-warning-300": "hsl(43, 89%, 56%)",
        "color-warning-40": "hsl(43, 89%, 88%)",
        "color-warning-400": "hsl(43, 89%, 52%)",
        "color-warning-450": "hsl(43, 89%, 44%)",
        "color-warning-50": "hsl(43, 89%, 84%)",
        "color-warning-500": "hsl(43, 89%, 39%)",
        "color-warning-550": "hsl(43, 89%, 35%)",
        "color-warning-60": "hsl(43, 89%, 79%)",
        "color-warning-600": "hsl(43, 89%, 31%)",
        "color-warning-650": "hsl(43, 89%, 27%)",
        "color-warning-70": "hsl(43, 89%, 76%)",
        "color-warning-700": "hsl(43, 89%, 24%)",
        "color-warning-750": "hsl(43, 89%, 17%)",
        "color-warning-80": "hsl(43, 89%, 72%)",
        "color-warning-800": "hsl(43, 89%, 12%)",
        "color-warning-850": "hsl(43, 89%, 8%)",
        "color-warning-90": "hsl(43, 89%, 68%)",
        "color-warning-900": "hsl(43, 89%, 3%)",
        "color-zero-state-base-fill-1": "hsl(219, 0%, 0%)",
        "color-zero-state-base-fill-2": "hsl(219, 12%, 72%)",
        "color-zero-state-base-fill-3": "hsl(219, 12%, 59%)",
        "color-zero-state-modifier-fill-1": "hsl(219, 12%, 22%)",
        "color-zero-state-modifier-fill-2": "hsl(212, 94%, 76%)",
        "color-zero-state-modifier-fill-3": "hsl(212, 94%, 57%)",
        "color-zero-state-modifier-fill-4": "hsl(219, 12%, 30%)",
        "color-zero-state-modifier-fill-5": "hsl(219, 12%, 88%)",
        "duration-100": "100ms",
        "duration-1000": "1s",
        "duration-200": "200ms",
        "duration-250": "250ms",
        "duration-300": "300ms",
        "duration-400": "400ms",
        "duration-450": "450ms",
        "duration-500": "500ms",
        "duration-700": "700ms",
        "ease-in": "cubic-bezier(0, 0.5, 0.2, 1)",
        "ease-in-out": "cubic-bezier(0.5, 0, 0.2, 1)",
        "ease-out": "cubic-bezier(0.5, 0, 0.8, 1)",
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "font-family-secondary": "'Anova', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "font-size-base-text": "16px",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "22.4px",
        "font-size-line-height-body-text-m": "19.6px",
        "font-size-line-height-body-text-s": "16.8px",
        "font-size-line-height-body-text-xl": "25.2px",
        "font-size-line-height-body-text-xs": "15.4px",
        "font-size-line-height-body-text-xxl": "28px",
        "font-size-line-height-body-text-xxs": "14px",
        "font-size-line-height-body-text-xxxl": "30.8px",
        "font-size-line-height-body-text-xxxs": "12.6px",
        "font-size-line-height-body-text-xxxxl": "35px",
        "font-size-line-height-display-text-1": "102.2px",
        "font-size-line-height-display-text-2": "81px",
        "font-size-line-height-display-text-3": "56px",
        "font-size-line-height-heading-text-l": "22.4px",
        "font-size-line-height-heading-text-m": "19.6px",
        "font-size-line-height-heading-text-s": "16.8px",
        "font-size-line-height-heading-text-xl": "25.2px",
        "font-size-line-height-heading-text-xxl": "28px",
        "font-size-line-height-heading-text-xxxl": "30.8px",
        "font-size-line-height-heading-text-xxxxl": "39.2px",
        "font-size-line-height-heading-text-xxxxxl": "81px",
        "font-size-ratio": "1.125",
        "font-size-ratio-major-second": "1.125",
        "font-size-ratio-major-third": "1.25",
        "font-size-ratio-minor-third": "1.2",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "2px",
        "font-space-letter-spacing-m": "1px",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "-1px",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "font-space-word": "normal",
        "font-space-word-l": "2px",
        "font-space-word-m": "normal",
        "font-space-word-s": "1px",
        "font-style-expression": "normal",
        "font-style-expression-italic": "italic",
        "font-style-expression-normal": "normal",
        "font-style-expression-oblique": "oblique",
        "font-style-overflow-wrap": "anywhere",
        "font-style-overflow-wrap-anywhere": "anywhere",
        "font-style-overflow-wrap-break-word": "break-word",
        "font-style-overflow-wrap-normal": "normal",
        "font-style-text-transform": "none",
        "font-style-text-transform-capitalize": "capitalize",
        "font-style-text-transform-lowercase": "lowercase",
        "font-style-text-transform-none": "none",
        "font-style-text-transform-uppercase": "uppercase",
        "font-style-weight-300": "300",
        "font-style-weight-400": "400",
        "font-style-weight-500": "500",
        "font-style-weight-600": "600",
        "font-style-weight-700": "700",
        "font-style-word-break": "break-all",
        "font-style-word-break-break-all": "break-all",
        "font-style-word-break-break-word": "break-word",
        "font-style-word-break-keep-all": "keep-all",
        "font-style-word-break-normal": "normal",
        "shadow-depth-l": "0 8px 12px rgba(0, 0, 0, 0.04), 0 16px 24px rgba(0, 0, 0, 0.08)",
        "shadow-depth-m": "0 2px 4px rgba(0, 0, 0, 0.04), 0 8px 16px rgba(0, 0, 0, 0.08)",
        "shadow-depth-s": "0 2px 2px rgba(0, 0, 0, 0.04), 0 4px 8px rgba(0, 0, 0, 0.08)",
        "shadow-depth-xl": "0 16px 24px rgba(0, 0, 0, 0.04), 0 32px 48px rgba(0, 0, 0, 0.08)",
        "shadow-depth-xs": "0 1px 2px rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.08)",
        "size-action-border-width-focus": "2px",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-border-width-l": "3px",
        "size-border-width-m": "2px",
        "size-border-width-null": "0",
        "size-border-width-s": "1px",
        "size-container-l": "400px",
        "size-container-m": "320px",
        "size-container-null": "0",
        "size-container-s": "240px",
        "size-container-xl": "640px",
        "size-container-xs": "192px",
        "size-container-xxl": "960px",
        "size-container-xxs": "96px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "size-outline-width-l": "3px",
        "size-outline-width-m": "2px",
        "size-outline-width-s": "1px",
        "size-outline-width-xl": "4px",
        "size-zero-state-border-width": "1px",
        "space-base-l": "1.4375rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem",
        "style-action-border-focus": "solid"
    }
};

const HighDensityChineseVariantsTokens = {
    "name": "high-density-chinese-variants",
    "selectors": ["[data-sas-theme='low-density']:lang(zh)", "[data-sas-theme='low-density']:lang(zh-cn)", "[data-sas-theme='low-density']:lang(zh-sg)", "[data-sas-theme='low-density']:lang(zh-hans)", "[data-sas-theme='low-density']:lang(zh-cn-pseudo)", "[data-sas-theme='low-density']:lang(zh-hk)", "[data-sas-theme='low-density']:lang(zh-tw)", "[data-sas-theme='low-density']:lang(zh-hant)"],
    "tokens": {
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "22.4px",
        "font-size-line-height-body-text-m": "19.6px",
        "font-size-line-height-body-text-s": "16.8px",
        "font-size-line-height-body-text-xl": "25.2px",
        "font-size-line-height-body-text-xs": "15.4px",
        "font-size-line-height-body-text-xxl": "28px",
        "font-size-line-height-body-text-xxs": "14px",
        "font-size-line-height-body-text-xxxl": "30.8px",
        "font-size-line-height-body-text-xxxs": "12.6px",
        "font-size-line-height-body-text-xxxxl": "35px",
        "font-size-line-height-display-text-1": "102.2px",
        "font-size-line-height-display-text-2": "81px",
        "font-size-line-height-display-text-3": "56px",
        "font-size-line-height-heading-text-l": "22.4px",
        "font-size-line-height-heading-text-m": "19.6px",
        "font-size-line-height-heading-text-s": "16.8px",
        "font-size-line-height-heading-text-xl": "25.2px",
        "font-size-line-height-heading-text-xxl": "28px",
        "font-size-line-height-heading-text-xxxl": "30.8px",
        "font-size-line-height-heading-text-xxxxl": "39.2px",
        "font-size-line-height-heading-text-xxxxxl": "81px",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "12px",
        "size-border-radius-m": "8px",
        "size-border-radius-s": "4px",
        "size-border-radius-xs": "2px",
        "size-border-radius-xxs": "1px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.125rem",
        "space-base-m": "0.75rem",
        "space-base-null": "0",
        "space-base-s": "0.375rem",
        "space-base-size": "1rem",
        "space-base-xl": "1.5rem",
        "space-base-xs": "0.1875rem",
        "space-base-xxl": "1.875rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.25rem",
        "space-base-xxxxl": "2.625rem",
        "space-base-xxxxxl": "3rem"
    }
};

const HighDensityEuroSlavicLocalesTokens = {
    "name": "high-density-euro-slavic-locales",
    "selectors": ["[data-sas-theme='high-density']:lang(en)"],
    "tokens": {
        "font-size-body-text-l": "0.875rem",
        "font-size-body-text-m": "0.75rem",
        "font-size-body-text-s": "0.6875rem",
        "font-size-body-text-xl": "0.9375rem",
        "font-size-body-text-xs": "0.5625rem",
        "font-size-body-text-xxl": "1.0625rem",
        "font-size-body-text-xxs": "0.5rem",
        "font-size-body-text-xxxl": "1.1875rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.375rem",
        "font-size-display-text-1": "3.875rem",
        "font-size-display-text-2": "3.0625re",
        "font-size-display-text-3": "2.1875rem",
        "font-size-heading-text-l": "0.875rem",
        "font-size-heading-text-m": "0.75rem",
        "font-size-heading-text-s": "0.6875rem",
        "font-size-heading-text-xl": "0.9375rem",
        "font-size-heading-text-xxl": "1.0625rem",
        "font-size-heading-text-xxxl": "1.1875rem",
        "font-size-heading-text-xxxxl": "1.5rem",
        "font-size-heading-text-xxxxxl": "2.4375rem",
        "font-size-heading-text-xxxxxxl": "3.0625rem",
        "font-size-line-height-body-text-l": "19.6px",
        "font-size-line-height-body-text-m": "16.8px",
        "font-size-line-height-body-text-s": "15.4px",
        "font-size-line-height-body-text-xl": "21px",
        "font-size-line-height-body-text-xs": "12.6px",
        "font-size-line-height-body-text-xxl": "23.8px",
        "font-size-line-height-body-text-xxs": "11.2px",
        "font-size-line-height-body-text-xxxl": "26.6px",
        "font-size-line-height-body-text-xxxs": "9.8px",
        "font-size-line-height-body-text-xxxxl": "30.8px",
        "font-size-line-height-display-text-1": "86.8px",
        "font-size-line-height-display-text-2": "68.6px",
        "font-size-line-height-display-text-3": "49px",
        "font-size-line-height-heading-text-l": "19.6px",
        "font-size-line-height-heading-text-m": "16.8px",
        "font-size-line-height-heading-text-s": "15.4px",
        "font-size-line-height-heading-text-xl": "21px",
        "font-size-line-height-heading-text-xxl": "23.8px",
        "font-size-line-height-heading-text-xxxl": "26.6px",
        "font-size-line-height-heading-text-xxxxl": "33.6px",
        "font-size-line-height-heading-text-xxxxxl": "68.6px",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "12px",
        "size-border-radius-m": "8px",
        "size-border-radius-s": "4px",
        "size-border-radius-xs": "2px",
        "size-border-radius-xxs": "1px",
        "size-icon-l": "0.875rem",
        "size-icon-m": "0.75rem",
        "size-icon-s": "0.6875rem",
        "size-icon-xl": "0.9375rem",
        "size-icon-xs": "0.6875rem",
        "size-icon-xxl": "1.0625rem",
        "size-icon-xxs": "0.6875rem",
        "size-icon-xxxl": "1.1875rem",
        "size-icon-xxxs": "0.6875rem",
        "size-icon-xxxxl": "1.375rem",
        "space-base-l": "1.25rem",
        "space-base-m": "0.875rem",
        "space-base-null": "0",
        "space-base-s": "0.4375rem",
        "space-base-size": "1rem",
        "space-base-xl": "1.75rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.25rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.5rem",
        "space-base-xxxxl": "3.1875rem",
        "space-base-xxxxxl": "3.625rem"
    }
};

const HighDensityMenaAsianLocalesTokens = {
    "name": "high-density-mena-asian-locales",
    "selectors": ["[data-sas-theme='high-density']:lang(ar)", "[data-sas-theme='high-density']:lang(ar-xx)", "[data-sas-theme='high-density']:lang(he)", "[data-sas-theme='high-density']:lang(jp)", "[data-sas-theme='high-density']:lang(ko)", "[data-sas-theme='high-density']:lang(th)", "[data-sas-theme='high-density']:lang(vi)", "[data-sas-theme='high-density']:lang(vi-VN)"],
    "tokens": {
        "font-size-body-text-l": "0.875rem",
        "font-size-body-text-m": "0.75rem",
        "font-size-body-text-s": "0.6875rem",
        "font-size-body-text-xl": "0.9375rem",
        "font-size-body-text-xs": "0.5625rem",
        "font-size-body-text-xxl": "1.0625rem",
        "font-size-body-text-xxs": "0.5rem",
        "font-size-body-text-xxxl": "1.1875rem",
        "font-size-body-text-xxxs": "0.4375rem",
        "font-size-body-text-xxxxl": "1.375rem",
        "font-size-display-text-1": "3.875rem",
        "font-size-display-text-2": "3.0625rem",
        "font-size-display-text-3": "2.1875rem",
        "font-size-heading-text-l": "0.875rem",
        "font-size-heading-text-m": "0.75rem",
        "font-size-heading-text-s": "0.6875rem",
        "font-size-heading-text-xl": "0.9375rem",
        "font-size-heading-text-xxl": "1.0625rem",
        "font-size-heading-text-xxxl": "1.1875rem",
        "font-size-heading-text-xxxxl": "1.5rem",
        "font-size-heading-text-xxxxxl": "2.4375rem",
        "font-size-heading-text-xxxxxxl": "3.0625rem",
        "font-size-line-height-body-text-l": "19.6px",
        "font-size-line-height-body-text-m": "16.8px",
        "font-size-line-height-body-text-s": "15.4px",
        "font-size-line-height-body-text-xl": "21px",
        "font-size-line-height-body-text-xs": "12.6px",
        "font-size-line-height-body-text-xxl": "23.8px",
        "font-size-line-height-body-text-xxs": "11.2px",
        "font-size-line-height-body-text-xxxl": "26.6px",
        "font-size-line-height-body-text-xxxs": "9.8px",
        "font-size-line-height-body-text-xxxxl": "30.8px",
        "font-size-line-height-display-text-1": "86.8px",
        "font-size-line-height-display-text-2": "68.6px",
        "font-size-line-height-display-text-3": "49px",
        "font-size-line-height-heading-text-l": "19.6px",
        "font-size-line-height-heading-text-m": "16.8px",
        "font-size-line-height-heading-text-s": "15.4px",
        "font-size-line-height-heading-text-xl": "21px",
        "font-size-line-height-heading-text-xxl": "23.8px",
        "font-size-line-height-heading-text-xxxl": "26.6px",
        "font-size-line-height-heading-text-xxxxl": "33.6px",
        "font-size-line-height-heading-text-xxxxxl": "68.6px",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "12px",
        "size-border-radius-m": "8px",
        "size-border-radius-s": "4px",
        "size-border-radius-xs": "2px",
        "size-border-radius-xxs": "1px",
        "size-icon-l": "0.875rem",
        "size-icon-m": "0.75rem",
        "size-icon-s": "0.6875rem",
        "size-icon-xl": "0.9375rem",
        "size-icon-xs": "0.6875rem",
        "size-icon-xxl": "1.0625rem",
        "size-icon-xxs": "0.6875rem",
        "size-icon-xxxl": "1.1875rem",
        "size-icon-xxxs": "0.6875rem",
        "size-icon-xxxxl": "1.375rem",
        "space-base-l": "1.125rem",
        "space-base-m": "0.75rem",
        "space-base-null": "0",
        "space-base-s": "0.375rem",
        "space-base-size": "1rem",
        "space-base-xl": "1.5rem",
        "space-base-xs": "0.1875rem",
        "space-base-xxl": "1.875rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.25rem",
        "space-base-xxxxl": "2.625rem",
        "space-base-xxxxxl": "3rem"
    }
};

const HighDensityTokens = {
    "name": "high-density",
    "selectors": ["[data-sas-theme='high-density']"],
    "tokens": {
        "font-size-body-text-l": "0.875rem",
        "font-size-body-text-m": "0.75rem",
        "font-size-body-text-s": "0.6875rem",
        "font-size-body-text-xl": "0.9375rem",
        "font-size-body-text-xs": "0.5625rem",
        "font-size-body-text-xxl": "1.0625rem",
        "font-size-body-text-xxs": "0.5rem",
        "font-size-body-text-xxxl": "1.1875rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.375rem",
        "font-size-display-text-1": "3.875rem",
        "font-size-display-text-2": "3.0625re",
        "font-size-display-text-3": "2.1875rem",
        "font-size-heading-text-l": "0.875rem",
        "font-size-heading-text-m": "0.75rem",
        "font-size-heading-text-s": "0.6875rem",
        "font-size-heading-text-xl": "0.9375rem",
        "font-size-heading-text-xxl": "1.0625rem",
        "font-size-heading-text-xxxl": "1.1875rem",
        "font-size-heading-text-xxxxl": "1.5rem",
        "font-size-heading-text-xxxxxl": "2.4375rem",
        "font-size-heading-text-xxxxxxl": "3.0625rem",
        "font-size-line-height-body-text-l": "19.6px",
        "font-size-line-height-body-text-m": "16.8px",
        "font-size-line-height-body-text-s": "15.4px",
        "font-size-line-height-body-text-xl": "21px",
        "font-size-line-height-body-text-xs": "12.6px",
        "font-size-line-height-body-text-xxl": "23.8px",
        "font-size-line-height-body-text-xxs": "11.2px",
        "font-size-line-height-body-text-xxxl": "26.6px",
        "font-size-line-height-body-text-xxxs": "9.8px",
        "font-size-line-height-body-text-xxxxl": "30.8px",
        "font-size-line-height-display-text-1": "86.8px",
        "font-size-line-height-display-text-2": "68.6px",
        "font-size-line-height-display-text-3": "49px",
        "font-size-line-height-heading-text-l": "19.6px",
        "font-size-line-height-heading-text-m": "16.8px",
        "font-size-line-height-heading-text-s": "15.4px",
        "font-size-line-height-heading-text-xl": "21px",
        "font-size-line-height-heading-text-xxl": "23.8px",
        "font-size-line-height-heading-text-xxxl": "26.6px",
        "font-size-line-height-heading-text-xxxxl": "33.6px",
        "font-size-line-height-heading-text-xxxxxl": "68.6px",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "12px",
        "size-border-radius-m": "8px",
        "size-border-radius-s": "4px",
        "size-border-radius-xs": "2px",
        "size-border-radius-xxs": "1px",
        "size-icon-l": "0.875rem",
        "size-icon-m": "0.75rem",
        "size-icon-s": "0.6875rem",
        "size-icon-xl": "0.9375rem",
        "size-icon-xs": "0.6875rem",
        "size-icon-xxl": "1.0625rem",
        "size-icon-xxs": "0.6875rem",
        "size-icon-xxxl": "1.1875rem",
        "size-icon-xxxs": "0.6875rem",
        "size-icon-xxxxl": "1.375rem",
        "space-base-l": "1.25rem",
        "space-base-m": "0.875rem",
        "space-base-null": "0",
        "space-base-s": "0.4375rem",
        "space-base-size": "1rem",
        "space-base-xl": "1.75rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.25rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.5rem",
        "space-base-xxxxl": "3.1875rem",
        "space-base-xxxxxl": "3.625rem"
    }
};

const JapaneseTokens = {
    "name": "japanese",
    "selectors": [":lang(jp)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AnovaUI', 'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', 'Osaka', 'メイリオ', 'Meiryo', 'ＭＳ Ｐゴシック', 'MS PGothic', 'Noto Sans JP', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'Anova', 'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', 'Osaka', 'メイリオ', 'Meiryo', 'ＭＳ Ｐゴシック', 'MS PGothic', 'Noto Sans JP', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "24px",
        "font-size-line-height-body-text-m": "21px",
        "font-size-line-height-body-text-s": "18px",
        "font-size-line-height-body-text-xl": "27px",
        "font-size-line-height-body-text-xs": "16.5px",
        "font-size-line-height-body-text-xxl": "30px",
        "font-size-line-height-body-text-xxs": "15px",
        "font-size-line-height-body-text-xxxl": "33px",
        "font-size-line-height-body-text-xxxs": "13.5px",
        "font-size-line-height-body-text-xxxxl": "37.5px",
        "font-size-line-height-display-text-1": "109.5px",
        "font-size-line-height-display-text-2": "87px",
        "font-size-line-height-display-text-3": "60px",
        "font-size-line-height-heading-text-l": "24px",
        "font-size-line-height-heading-text-m": "21px",
        "font-size-line-height-heading-text-s": "18px",
        "font-size-line-height-heading-text-xl": "27px",
        "font-size-line-height-heading-text-xxl": "30px",
        "font-size-line-height-heading-text-xxxl": "33px",
        "font-size-line-height-heading-text-xxxxl": "42px",
        "font-size-line-height-heading-text-xxxxxl": "87px",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-expression-italic": "normal",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "3rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4rem"
    }
};

const KoreanTokens = {
    "name": "korean",
    "selectors": [":lang(ko)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AnovaUI', '맑은 고딕', 'Malgun Gothic', 'Apple SD Gothic Neo', 'NanumBarunGothic', '굴림', 'Gulim', '돋움', 'Dotum', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'Anova', '맑은 고딕', 'Malgun Gothic', 'Apple SD Gothic Neo', 'NanumBarunGothic', '굴림', 'Gulim', '돋움', 'Dotum', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "24px",
        "font-size-line-height-body-text-m": "21px",
        "font-size-line-height-body-text-s": "18px",
        "font-size-line-height-body-text-xl": "27px",
        "font-size-line-height-body-text-xs": "16.5px",
        "font-size-line-height-body-text-xxl": "30px",
        "font-size-line-height-body-text-xxs": "15px",
        "font-size-line-height-body-text-xxxl": "33px",
        "font-size-line-height-body-text-xxxs": "13.5px",
        "font-size-line-height-body-text-xxxxl": "37.5px",
        "font-size-line-height-display-text-1": "109.5px",
        "font-size-line-height-display-text-2": "87px",
        "font-size-line-height-display-text-3": "60px",
        "font-size-line-height-heading-text-l": "24px",
        "font-size-line-height-heading-text-m": "21px",
        "font-size-line-height-heading-text-s": "18px",
        "font-size-line-height-heading-text-xl": "27px",
        "font-size-line-height-heading-text-xxl": "30px",
        "font-size-line-height-heading-text-xxxl": "33px",
        "font-size-line-height-heading-text-xxxxl": "42px",
        "font-size-line-height-heading-text-xxxxxl": "87px",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-expression-italic": "normal",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "3rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4rem"
    }
};

const LightTokens = {
    "name": "light",
    "selectors": [":root", "[data-sas-theme='light']"],
    "tokens": {
        "brand-color-alert": "hsl(0, 100%, 40%)",
        "brand-color-alert-00": "hsl(0, 0%, 100%)",
        "brand-color-alert-10": "hsl(0, 100%, 98%)",
        "brand-color-alert-100": "hsl(0, 100%, 64%)",
        "brand-color-alert-1000": "hsl(0, 0%, 0%)",
        "brand-color-alert-20": "hsl(0, 100%, 95%)",
        "brand-color-alert-200": "hsl(0, 100%, 59%)",
        "brand-color-alert-30": "hsl(0, 100%, 92%)",
        "brand-color-alert-300": "hsl(0, 100%, 54%)",
        "brand-color-alert-40": "hsl(0, 100%, 88%)",
        "brand-color-alert-400": "hsl(0, 100%, 46%)",
        "brand-color-alert-450": "hsl(0, 100%, 40%)",
        "brand-color-alert-50": "hsl(0, 100%, 84%)",
        "brand-color-alert-500": "hsl(0, 100%, 36%)",
        "brand-color-alert-550": "hsl(0, 100%, 33%)",
        "brand-color-alert-60": "hsl(0, 100%, 79%)",
        "brand-color-alert-600": "hsl(0, 100%, 30%)",
        "brand-color-alert-650": "hsl(0, 100%, 27%)",
        "brand-color-alert-70": "hsl(0, 100%, 76%)",
        "brand-color-alert-700": "hsl(0, 100%, 22%)",
        "brand-color-alert-750": "hsl(0, 100%, 17%)",
        "brand-color-alert-80": "hsl(0, 100%, 72%)",
        "brand-color-alert-800": "hsl(0, 100%, 12%)",
        "brand-color-alert-850": "hsl(0, 100%, 8%)",
        "brand-color-alert-90": "hsl(0, 100%, 68%)",
        "brand-color-alert-900": "hsl(0, 100%, 3%)",
        "brand-color-blue": "hsl(212, 94%, 42%)",
        "brand-color-blue-00": "hsl(212, 0%, 100%)",
        "brand-color-blue-10": "hsl(212, 94%, 97%)",
        "brand-color-blue-100": "hsl(212, 94%, 62%)",
        "brand-color-blue-1000": "hsl(212, 0%, 0%)",
        "brand-color-blue-20": "hsl(212, 94%, 94%)",
        "brand-color-blue-200": "hsl(212, 94%, 57%)",
        "brand-color-blue-30": "hsl(212, 94%, 90%)",
        "brand-color-blue-300": "hsl(212, 94%, 53%)",
        "brand-color-blue-40": "hsl(212, 94%, 88%)",
        "brand-color-blue-400": "hsl(212, 94%, 47%)",
        "brand-color-blue-450": "hsl(212, 94%, 42%)",
        "brand-color-blue-50": "hsl(212, 94%, 83%)",
        "brand-color-blue-500": "hsl(212, 94%, 36%)",
        "brand-color-blue-550": "hsl(212, 94%, 35%)",
        "brand-color-blue-60": "hsl(212, 94%, 78%)",
        "brand-color-blue-600": "hsl(212, 94%, 31%)",
        "brand-color-blue-650": "hsl(212, 94%, 27%)",
        "brand-color-blue-70": "hsl(212, 94%, 76%)",
        "brand-color-blue-700": "hsl(212, 94%, 23%)",
        "brand-color-blue-750": "hsl(212, 94%, 17%)",
        "brand-color-blue-80": "hsl(212, 94%, 72%)",
        "brand-color-blue-800": "hsl(212, 94%, 12%)",
        "brand-color-blue-850": "hsl(212, 94%, 8%)",
        "brand-color-blue-90": "hsl(212, 94%, 68%)",
        "brand-color-blue-900": "hsl(212, 94%, 3%)",
        "brand-color-cranberry": "hsl(329, 60%, 40%)",
        "brand-color-cranberry-00": "hsl(329,60%,100%)",
        "brand-color-cranberry-10": "hsl(329,60%,98%)",
        "brand-color-cranberry-100": "hsl(329,60%,62%)",
        "brand-color-cranberry-1000": "hsl(329,60%,0%)",
        "brand-color-cranberry-20": "hsl(329,60%,97%)",
        "brand-color-cranberry-200": "hsl(329,60%,57%)",
        "brand-color-cranberry-30": "hsl(329,60%,92%)",
        "brand-color-cranberry-300": "hsl(329,60%,55%)",
        "brand-color-cranberry-40": "hsl(329,60%,88%)",
        "brand-color-cranberry-400": "hsl(329,60%,52%)",
        "brand-color-cranberry-450": "hsl(329,60%,40%)",
        "brand-color-cranberry-50": "hsl(329,60%,84%)",
        "brand-color-cranberry-500": "hsl(329,60%,37%)",
        "brand-color-cranberry-550": "hsl(329,60%,32%)",
        "brand-color-cranberry-60": "hsl(329,60%,78%)",
        "brand-color-cranberry-600": "hsl(329,60%,30%)",
        "brand-color-cranberry-650": "hsl(329,60%,27%)",
        "brand-color-cranberry-70": "hsl(329,60%,76%)",
        "brand-color-cranberry-700": "hsl(329,60%,22%)",
        "brand-color-cranberry-750": "hsl(329,60%,16%)",
        "brand-color-cranberry-80": "hsl(329,60%,72%)",
        "brand-color-cranberry-800": "hsl(329,60%,11%)",
        "brand-color-cranberry-850": "hsl(329,60%,9%)",
        "brand-color-cranberry-90": "hsl(329,60%,68%)",
        "brand-color-cranberry-900": "hsl(329,60%,4%)",
        "brand-color-grey": "hsl(219, 12%, 42%)",
        "brand-color-grey-00": "hsl(219, 0%, 100%)",
        "brand-color-grey-10": "hsl(219, 12%, 98%)",
        "brand-color-grey-100": "hsl(219, 12%, 64%)",
        "brand-color-grey-1000": "hsl(219, 0%, 0%)",
        "brand-color-grey-20": "hsl(219, 12%, 96%)",
        "brand-color-grey-200": "hsl(219, 12%, 59%)",
        "brand-color-grey-30": "hsl(219, 12%, 92%)",
        "brand-color-grey-300": "hsl(219, 12%, 55%)",
        "brand-color-grey-40": "hsl(219, 12%, 88%)",
        "brand-color-grey-400": "hsl(219, 12%, 48%)",
        "brand-color-grey-450": "hsl(219, 12%, 42%)",
        "brand-color-grey-50": "hsl(219, 12%, 84%)",
        "brand-color-grey-500": "hsl(219, 12%, 36%)",
        "brand-color-grey-550": "hsl(219, 12%, 33%)",
        "brand-color-grey-60": "hsl(219, 12%, 79%)",
        "brand-color-grey-600": "hsl(219, 12%, 30%)",
        "brand-color-grey-650": "hsl(219, 12%, 27%)",
        "brand-color-grey-70": "hsl(219, 12%, 76%)",
        "brand-color-grey-700": "hsl(219, 12%, 22%)",
        "brand-color-grey-750": "hsl(219, 12%, 17%)",
        "brand-color-grey-80": "hsl(219, 12%, 72%)",
        "brand-color-grey-800": "hsl(219, 12%, 12%)",
        "brand-color-grey-850": "hsl(219, 12%, 8%)",
        "brand-color-grey-90": "hsl(219, 12%, 68%)",
        "brand-color-grey-900": "hsl(219, 12%, 3%)",
        "brand-color-info": "hsl(212, 94%, 42%)",
        "brand-color-info-00": "hsl(212, 0%, 100%)",
        "brand-color-info-10": "hsl(212, 94%, 97%)",
        "brand-color-info-100": "hsl(212, 94%, 62%)",
        "brand-color-info-1000": "hsl(212, 0%, 0%)",
        "brand-color-info-20": "hsl(212, 94%, 94%)",
        "brand-color-info-200": "hsl(212, 94%, 57%)",
        "brand-color-info-30": "hsl(212, 94%, 90%)",
        "brand-color-info-300": "hsl(212, 94%, 53%)",
        "brand-color-info-40": "hsl(212, 94%, 88%)",
        "brand-color-info-400": "hsl(212, 94%, 47%)",
        "brand-color-info-450": "hsl(212, 94%, 42%)",
        "brand-color-info-50": "hsl(212, 94%, 83%)",
        "brand-color-info-500": "hsl(212, 94%, 36%)",
        "brand-color-info-550": "hsl(212, 94%, 35%)",
        "brand-color-info-60": "hsl(212, 94%, 78%)",
        "brand-color-info-600": "hsl(212, 94%, 31%)",
        "brand-color-info-650": "hsl(212, 94%, 27%)",
        "brand-color-info-70": "hsl(212, 94%, 76%)",
        "brand-color-info-700": "hsl(212, 94%, 23%)",
        "brand-color-info-750": "hsl(212, 94%, 17%)",
        "brand-color-info-80": "hsl(212, 94%, 72%)",
        "brand-color-info-800": "hsl(212, 94%, 12%)",
        "brand-color-info-850": "hsl(212, 94%, 8%)",
        "brand-color-info-90": "hsl(212, 94%, 68%)",
        "brand-color-info-900": "hsl(212, 94%, 3%)",
        "brand-color-success": "hsl(123, 46%, 43%)",
        "brand-color-success-00": "hsl(123, 0%, 100%)",
        "brand-color-success-10": "hsl(123, 46%, 98%)",
        "brand-color-success-100": "hsl(123, 46%, 63%)",
        "brand-color-success-1000": "hsl(123, 0%, 0%)",
        "brand-color-success-20": "hsl(123, 46%, 95%)",
        "brand-color-success-200": "hsl(123, 46%, 58%)",
        "brand-color-success-30": "hsl(123, 46%, 90%)",
        "brand-color-success-300": "hsl(123, 46%, 55%)",
        "brand-color-success-40": "hsl(123, 46%, 87%)",
        "brand-color-success-400": "hsl(123, 46%, 48%)",
        "brand-color-success-450": "hsl(123, 46%, 43%)",
        "brand-color-success-50": "hsl(123, 46%, 82%)",
        "brand-color-success-500": "hsl(123, 46%, 36%)",
        "brand-color-success-550": "hsl(123, 46%, 34%)",
        "brand-color-success-60": "hsl(123, 46%, 78%)",
        "brand-color-success-600": "hsl(123, 46%, 30%)",
        "brand-color-success-650": "hsl(123, 46%, 25%)",
        "brand-color-success-70": "hsl(123, 46%, 75%)",
        "brand-color-success-700": "hsl(123, 46%, 22%)",
        "brand-color-success-750": "hsl(123, 46%, 17%)",
        "brand-color-success-80": "hsl(123, 46%, 70%)",
        "brand-color-success-800": "hsl(123, 46%, 12%)",
        "brand-color-success-850": "hsl(123, 46%, 8%)",
        "brand-color-success-90": "hsl(123, 46%, 66%)",
        "brand-color-success-900": "hsl(123, 46%, 3%)",
        "brand-color-warning": "hsl(43, 89%, 44%)",
        "brand-color-warning-00": "hsl(43, 0%, 100%)",
        "brand-color-warning-10": "hsl(43, 89%, 98%)",
        "brand-color-warning-100": "hsl(43, 89%, 64%)",
        "brand-color-warning-1000": "hsl(43, 0%, 0%)",
        "brand-color-warning-20": "hsl(43, 89%, 95%)",
        "brand-color-warning-200": "hsl(43, 89%, 60%)",
        "brand-color-warning-30": "hsl(43, 89%, 92%)",
        "brand-color-warning-300": "hsl(43, 89%, 56%)",
        "brand-color-warning-40": "hsl(43, 89%, 88%)",
        "brand-color-warning-400": "hsl(43, 89%, 52%)",
        "brand-color-warning-450": "hsl(43, 89%, 44%)",
        "brand-color-warning-50": "hsl(43, 89%, 84%)",
        "brand-color-warning-500": "hsl(43, 89%, 39%)",
        "brand-color-warning-550": "hsl(43, 89%, 35%)",
        "brand-color-warning-60": "hsl(43, 89%, 79%)",
        "brand-color-warning-600": "hsl(43, 89%, 31%)",
        "brand-color-warning-650": "hsl(43, 89%, 27%)",
        "brand-color-warning-70": "hsl(43, 89%, 76%)",
        "brand-color-warning-700": "hsl(43, 89%, 24%)",
        "brand-color-warning-750": "hsl(43, 89%, 17%)",
        "brand-color-warning-80": "hsl(43, 89%, 72%)",
        "brand-color-warning-800": "hsl(43, 89%, 12%)",
        "brand-color-warning-850": "hsl(43, 89%, 8%)",
        "brand-color-warning-90": "hsl(43, 89%, 68%)",
        "brand-color-warning-900": "hsl(43, 89%, 3%)",
        "color-action-background-control-alert": "hsl(0, 100%, 95%)",
        "color-action-background-control-disabled": "hsl(219, 0%, 100%)",
        "color-action-background-control-hover": "hsl(219, 12%, 96%)",
        "color-action-background-control-normal": "hsl(219, 12%, 98%)",
        "color-action-background-control-primary": "hsl(212, 94%, 42%)",
        "color-action-background-control-read-only": "hsl(219, 0%, 100%)",
        "color-action-background-control-selected": "hsl(212, 94%, 94%)",
        "color-action-background-control-warning": "hsl(43, 89%, 95%)",
        "color-action-background-emphasis-active": "hsl(212, 94%, 31%)",
        "color-action-background-emphasis-disabled": "hsl(219, 12%, 96%)",
        "color-action-background-emphasis-hover": "hsl(212, 94%, 31%)",
        "color-action-background-emphasis-normal": "hsl(212, 94%, 42%)",
        "color-action-background-emphasis-selected": "hsl(212, 94%, 31%)",
        "color-action-background-emphasis-visited": "hsl(212, 94%, 42%)",
        "color-action-background-focus": "hsl(205, 97%, 35%)",
        "color-action-background-focus-inverse": "hsl(0, 100%, 100%)",
        "color-action-background-on-off-disabled": "hsl(219, 12%, 96%)",
        "color-action-background-on-off-hover": "hsl(219, 12%, 96%)",
        "color-action-background-on-off-normal": "hsl(219, 0%, 100%)",
        "color-action-background-on-off-read-only": "hsl(219, 12%, 98%)",
        "color-action-background-on-off-selected": "hsl(212, 94%, 42%)",
        "color-action-background-on-off-selected-disabled": "hsl(212, 94%, 94%)",
        "color-action-background-standard-active": "hsl(212, 94%, 90%)",
        "color-action-background-standard-disabled": "hsl(219, 12%, 96%)",
        "color-action-background-standard-hover": "hsl(219, 12%, 96%)",
        "color-action-background-standard-normal": "hsl(219, 12%, 98%)",
        "color-action-background-standard-selected": "hsl(212, 94%, 90%)",
        "color-action-background-standard-selected-disabled": "hsl(212, 94%, 94%)",
        "color-action-background-standard-selected-inactive": "hsl(219, 12%, 92%)",
        "color-action-background-standard-visited": "hsl(219, 12%, 98%)",
        "color-action-background-subtle-disabled": "hsla(0, 0%, 100%, 0)",
        "color-action-background-subtle-hover": "hsl(219, 12%, 96%)",
        "color-action-background-subtle-normal": "hsla(0, 0%, 100%, 0)",
        "color-action-background-subtle-selected": "hsl(212, 94%, 90%)",
        "color-action-background-subtle-selected-disabled": "hsl(212, 94%, 94%)",
        "color-action-background-subtle-selected-inactive": "hsl(219, 12%, 92%)",
        "color-action-border-bottom-control-alert": "hsl(0, 100%, 46%)",
        "color-action-border-bottom-control-hover": "hsl(219, 12%, 59%)",
        "color-action-border-bottom-control-normal": "hsl(219, 12%, 59%)",
        "color-action-border-bottom-control-selected": "hsl(212, 94%, 42%)",
        "color-action-border-bottom-control-warning": "hsl(43, 89%, 52%)",
        "color-action-border-control-alert": "hsl(0, 100%, 46%)",
        "color-action-border-control-disabled": "hsl(219, 12%, 79%)",
        "color-action-border-control-hover": "hsl(219, 12%, 96%)",
        "color-action-border-control-normal": "hsl(219, 12%, 98%)",
        "color-action-border-control-read-only": "hsl(219, 0%, 100%)",
        "color-action-border-control-selected": "hsl(212, 94%, 94%)",
        "color-action-border-control-warning": "hsl(43, 89%, 52%)",
        "color-action-border-emphasis-active": "hsl(212, 94%, 31%)",
        "color-action-border-emphasis-disabled": "hsl(219, 12%, 96%)",
        "color-action-border-emphasis-hover": "hsl(212, 94%, 31%)",
        "color-action-border-emphasis-normal": "hsl(212, 94%, 42%)",
        "color-action-border-emphasis-selected": "hsl(212, 94%, 31%)",
        "color-action-border-emphasis-visited": "hsl(212, 94%, 42%)",
        "color-action-border-focus": "hsl(212, 94%, 31%)",
        "color-action-border-focus-inverse": "hsl(212, 0%, 100%)",
        "color-action-border-on-off-disabled": "hsl(219, 12%, 96%)",
        "color-action-border-on-off-hover": "hsl(219, 12%, 59%)",
        "color-action-border-on-off-normal": "hsl(219, 12%, 59%)",
        "color-action-border-on-off-read-only": "hsl(219, 12%, 59%)",
        "color-action-border-on-off-selected": "hsl(212, 94%, 42%)",
        "color-action-border-on-off-selected-disabled": "hsl(212, 94%, 94%)",
        "color-action-border-standard-active": "hsl(212, 94%, 42%)",
        "color-action-border-standard-disabled": "hsl(219, 12%, 96%)",
        "color-action-border-standard-hover": "hsl(219, 12%, 59%)",
        "color-action-border-standard-normal": "hsl(219, 12%, 88%)",
        "color-action-border-standard-selected": "hsl(212, 94%, 42%)",
        "color-action-border-standard-selected-disabled": "hsl(212, 94%, 94%)",
        "color-action-border-standard-selected-inactive": "hsl(219, 12%, 92%)",
        "color-action-border-standard-visited": "hsl(219, 12%, 88%)",
        "color-action-border-subtle-disabled": "hsla(0, 0%, 100%, 0)",
        "color-action-border-subtle-hover": "hsl(219, 12%, 96%)",
        "color-action-border-subtle-normal": "hsla(0, 0%, 100%, 0)",
        "color-action-border-subtle-selected": "hsl(212, 94%, 90%)",
        "color-action-border-subtle-selected-disabled": "hsl(212, 94%, 94%)",
        "color-action-border-subtle-selected-inactive": "hsl(219, 12%, 92%)",
        "color-action-focus": "hsl(212, 94%, 31%)",
        "color-action-icon-control-alert": "hsl(219, 12%, 12%)",
        "color-action-icon-control-disabled": "hsl(219, 12%, 79%)",
        "color-action-icon-control-hover": "hsl(219, 12%, 12%)",
        "color-action-icon-control-normal": "hsl(219, 12%, 12%)",
        "color-action-icon-control-read-only": "hsl(219, 12%, 12%)",
        "color-action-icon-control-selected": "hsl(219, 12%, 12%)",
        "color-action-icon-control-warning": "hsl(219, 12%, 12%)",
        "color-action-icon-emphasis-active": "hsl(212, 0%, 100%)",
        "color-action-icon-emphasis-disabled": "hsl(219, 12%, 79%)",
        "color-action-icon-emphasis-hover": "hsl(212, 94%, 94%)",
        "color-action-icon-emphasis-normal": "hsl(212, 0%, 100%)",
        "color-action-icon-emphasis-selected": "hsl(212, 0%, 100%)",
        "color-action-icon-emphasis-visited": "hsl(219, 12%, 88%)",
        "color-action-icon-on-off-disabled": "hsl(219, 12%, 79%)",
        "color-action-icon-on-off-hover": "hsl(219, 12%, 12%)",
        "color-action-icon-on-off-normal": "hsl(219, 12%, 12%)",
        "color-action-icon-on-off-read-only": "hsl(219, 12%, 12%)",
        "color-action-icon-on-off-selected": "hsl(219, 0%, 100%)",
        "color-action-icon-on-off-selected-disabled": "hsl(219, 12%, 79%)",
        "color-action-icon-standard-active": "hsl(212, 94%, 31%)",
        "color-action-icon-standard-disabled": "hsl(219, 12%, 79%)",
        "color-action-icon-standard-hover": "hsl(219, 12%, 12%)",
        "color-action-icon-standard-normal": "hsl(219, 12%, 12%)",
        "color-action-icon-standard-selected": "hsl(212, 94%, 31%)",
        "color-action-icon-standard-selected-disabled": "hsl(212, 94%, 88%)",
        "color-action-icon-standard-selected-inactive": "hsl(219, 12%, 12%)",
        "color-action-icon-standard-visited": "hsl(219, 12%, 12%)",
        "color-action-icon-subtle-disabled": "hsl(219, 12%, 79%)",
        "color-action-icon-subtle-hover": "hsl(219, 12%, 12%)",
        "color-action-icon-subtle-normal": "hsl(219, 12%, 12%)",
        "color-action-icon-subtle-selected": "hsl(212, 94%, 31%)",
        "color-action-icon-subtle-selected-disabled": "hsl(212, 94%, 88%)",
        "color-action-icon-subtle-selected-inactive": "hsl(219, 12%, 12%)",
        "color-action-link-active": "hsl(219, 12%, 12%)",
        "color-action-link-hover": "hsl(212, 94%, 42%)",
        "color-action-link-normal": "hsl(212, 94%, 42%)",
        "color-action-link-visited": "hsl(212, 94%, 42%)",
        "color-action-text-control-alert": "hsl(219, 12%, 12%)",
        "color-action-text-control-disabled": "hsl(219, 12%, 79%)",
        "color-action-text-control-hover": "hsl(219, 12%, 12%)",
        "color-action-text-control-normal": "hsl(219, 12%, 12%)",
        "color-action-text-control-placeholder": "hsl(219, 12%, 36%)",
        "color-action-text-control-read-only": "hsl(219, 12%, 12%)",
        "color-action-text-control-selected": "hsl(219, 12%, 12%)",
        "color-action-text-control-warning": "hsl(219, 12%, 12%)",
        "color-action-text-emphasis-active": "hsl(212, 0%, 100%)",
        "color-action-text-emphasis-disabled": "hsl(219, 12%, 79%)",
        "color-action-text-emphasis-hover": "hsl(212, 94%, 94%)",
        "color-action-text-emphasis-normal": "hsl(212, 0%, 100%)",
        "color-action-text-emphasis-selected": "hsl(212, 0%, 100%)",
        "color-action-text-emphasis-visited": "hsl(212, 0%, 100%)",
        "color-action-text-on-off-disabled": "hsl(219, 12%, 79%)",
        "color-action-text-on-off-hover": "hsl(219, 12%, 12%)",
        "color-action-text-on-off-normal": "hsl(219, 12%, 12%)",
        "color-action-text-on-off-read-only": "hsl(219, 12%, 12%)",
        "color-action-text-on-off-selected": "hsl(219, 0%, 100%)",
        "color-action-text-on-off-selected-disabled": "hsl(219, 12%, 79%)",
        "color-action-text-standard-active": "hsl(212, 0%, 100%)",
        "color-action-text-standard-disabled": "hsl(219, 12%, 79%)",
        "color-action-text-standard-hover": "hsl(219, 12%, 12%)",
        "color-action-text-standard-normal": "hsl(219, 12%, 12%)",
        "color-action-text-standard-selected": "hsl(212, 94%, 31%)",
        "color-action-text-standard-selected-disabled": "hsl(212, 94%, 88%)",
        "color-action-text-standard-selected-inactive": "hsl(219, 12%, 12%)",
        "color-action-text-standard-visited": "hsl(219, 12%, 12%)",
        "color-action-text-subtle-disabled": "hsl(219, 12%, 79%)",
        "color-action-text-subtle-hover": "hsl(219, 12%, 12%)",
        "color-action-text-subtle-normal": "hsl(219, 12%, 12%)",
        "color-action-text-subtle-selected": "hsl(212, 94%, 31%)",
        "color-action-text-subtle-selected-disabled": "hsl(212, 94%, 88%)",
        "color-action-text-subtle-selected-inactive": "hsl(219, 12%, 12%)",
        "color-alert-00": "hsl(0, 0%, 100%)",
        "color-alert-10": "hsl(0, 100%, 98%)",
        "color-alert-100": "hsl(0, 100%, 64%)",
        "color-alert-1000": "hsl(0, 0%, 0%)",
        "color-alert-20": "hsl(0, 100%, 95%)",
        "color-alert-200": "hsl(0, 100%, 59%)",
        "color-alert-30": "hsl(0, 100%, 92%)",
        "color-alert-300": "hsl(0, 100%, 54%)",
        "color-alert-40": "hsl(0, 100%, 88%)",
        "color-alert-400": "hsl(0, 100%, 46%)",
        "color-alert-450": "hsl(0, 100%, 40%)",
        "color-alert-50": "hsl(0, 100%, 84%)",
        "color-alert-500": "hsl(0, 100%, 36%)",
        "color-alert-550": "hsl(0, 100%, 33%)",
        "color-alert-60": "hsl(0, 100%, 79%)",
        "color-alert-600": "hsl(0, 100%, 30%)",
        "color-alert-650": "hsl(0, 100%, 27%)",
        "color-alert-70": "hsl(0, 100%, 76%)",
        "color-alert-700": "hsl(0, 100%, 22%)",
        "color-alert-750": "hsl(0, 100%, 17%)",
        "color-alert-80": "hsl(0, 100%, 72%)",
        "color-alert-800": "hsl(0, 100%, 12%)",
        "color-alert-850": "hsl(0, 100%, 8%)",
        "color-alert-90": "hsl(0, 100%, 68%)",
        "color-alert-900": "hsl(0, 100%, 3%)",
        "color-body-icon": "hsl(219, 12%, 12%)",
        "color-body-text": "hsl(219, 12%, 12%)",
        "color-container-background-0": "hsl(219, 0%, 100%)",
        "color-container-background-1": "hsl(219, 12%, 98%)",
        "color-container-background-2": "hsl(219, 12%, 96%)",
        "color-container-background-3": "hsl(212, 94%, 42%)",
        "color-container-background-4": "hsl(219, 12%, 88%)",
        "color-container-border-4": "hsl(219, 12%, 88%)",
        "color-dataviz-graph-alt1": "#287FC7",
        "color-dataviz-graph-alt2": "#C79F27",
        "color-dataviz-graph-alt3": "#7358C7",
        "color-dataviz-graph-alt4": "#C7651C",
        "color-dataviz-graph-alt5": "#1F9999",
        "color-dataviz-graph-alt6": "#A64141",
        "color-dataviz-graph-alt7": "#0E7D55",
        "color-dataviz-graph-alt8": "#C75793",
        "color-dataviz-graph1": "#33a3ff",
        "color-dataviz-graph2": "#fc3",
        "color-dataviz-graph3": "#9470ff",
        "color-dataviz-graph4": "#ff8324",
        "color-dataviz-graph5": "#29d1d1",
        "color-dataviz-graph6": "#dc5656",
        "color-dataviz-graph7": "#15b77b",
        "color-dataviz-graph8": "#ff70bc",
        "color-dataviz-kpi-alt1": "#A64141",
        "color-dataviz-kpi-alt3": "#C79F27",
        "color-dataviz-kpi-alt5": "#0E7D55",
        "color-dataviz-kpi1": "#dd5757",
        "color-dataviz-kpi3": "#ffcc32",
        "color-dataviz-kpi5": "#15b57b",
        "color-display-icon": "hsl(219, 12%, 12%)",
        "color-display-text": "hsl(219, 12%, 12%)",
        "color-heading-icon": "hsl(219, 12%, 12%)",
        "color-heading-text": "hsl(219, 12%, 12%)",
        "color-highlight-text": "hsl(212, 94%, 42%)",
        "color-highlight-text-inverse": "hsl(212, 0%, 100%)",
        "color-icon-neutral": "hsl(219, 12%, 12%)",
        "color-icon-primary": "hsl(212, 94%, 42%)",
        "color-icon-secondary": "hsl(329,60%,30%)",
        "color-info-00": "hsl(212, 0%, 100%)",
        "color-info-10": "hsl(212, 94%, 97%)",
        "color-info-100": "hsl(212, 94%, 62%)",
        "color-info-1000": "hsl(212, 0%, 0%)",
        "color-info-20": "hsl(212, 94%, 94%)",
        "color-info-200": "hsl(212, 94%, 57%)",
        "color-info-30": "hsl(212, 94%, 90%)",
        "color-info-300": "hsl(212, 94%, 53%)",
        "color-info-40": "hsl(212, 94%, 88%)",
        "color-info-400": "hsl(212, 94%, 47%)",
        "color-info-450": "hsl(212, 94%, 42%)",
        "color-info-50": "hsl(212, 94%, 83%)",
        "color-info-500": "hsl(212, 94%, 36%)",
        "color-info-550": "hsl(212, 94%, 35%)",
        "color-info-60": "hsl(212, 94%, 78%)",
        "color-info-600": "hsl(212, 94%, 31%)",
        "color-info-650": "hsl(212, 94%, 27%)",
        "color-info-70": "hsl(212, 94%, 76%)",
        "color-info-700": "hsl(212, 94%, 23%)",
        "color-info-750": "hsl(212, 94%, 17%)",
        "color-info-80": "hsl(212, 94%, 72%)",
        "color-info-800": "hsl(212, 94%, 12%)",
        "color-info-850": "hsl(212, 94%, 8%)",
        "color-info-90": "hsl(212, 94%, 68%)",
        "color-info-900": "hsl(212, 94%, 3%)",
        "color-label-text": "hsl(219, 12%, 48%)",
        "color-neutral": "hsl(219, 12%, 42%)",
        "color-neutral-00": "hsl(219, 0%, 100%)",
        "color-neutral-10": "hsl(219, 12%, 98%)",
        "color-neutral-100": "hsl(219, 12%, 64%)",
        "color-neutral-1000": "hsl(219, 0%, 0%)",
        "color-neutral-20": "hsl(219, 12%, 96%)",
        "color-neutral-200": "hsl(219, 12%, 59%)",
        "color-neutral-30": "hsl(219, 12%, 92%)",
        "color-neutral-300": "hsl(219, 12%, 55%)",
        "color-neutral-40": "hsl(219, 12%, 88%)",
        "color-neutral-400": "hsl(219, 12%, 48%)",
        "color-neutral-450": "hsl(219, 12%, 42%)",
        "color-neutral-50": "hsl(219, 12%, 84%)",
        "color-neutral-500": "hsl(219, 12%, 36%)",
        "color-neutral-550": "hsl(219, 12%, 33%)",
        "color-neutral-60": "hsl(219, 12%, 79%)",
        "color-neutral-600": "hsl(219, 12%, 30%)",
        "color-neutral-650": "hsl(219, 12%, 27%)",
        "color-neutral-70": "hsl(219, 12%, 76%)",
        "color-neutral-700": "hsl(219, 12%, 22%)",
        "color-neutral-750": "hsl(219, 12%, 17%)",
        "color-neutral-80": "hsl(219, 12%, 72%)",
        "color-neutral-800": "hsl(219, 12%, 12%)",
        "color-neutral-850": "hsl(219, 12%, 8%)",
        "color-neutral-90": "hsl(219, 12%, 68%)",
        "color-neutral-900": "hsl(219, 12%, 3%)",
        "color-primary": "hsl(212, 94%, 42%)",
        "color-primary-00": "hsl(212, 0%, 100%)",
        "color-primary-10": "hsl(212, 94%, 97%)",
        "color-primary-100": "hsl(212, 94%, 62%)",
        "color-primary-1000": "hsl(212, 0%, 0%)",
        "color-primary-20": "hsl(212, 94%, 94%)",
        "color-primary-200": "hsl(212, 94%, 57%)",
        "color-primary-30": "hsl(212, 94%, 90%)",
        "color-primary-300": "hsl(212, 94%, 53%)",
        "color-primary-40": "hsl(212, 94%, 88%)",
        "color-primary-400": "hsl(212, 94%, 47%)",
        "color-primary-450": "hsl(212, 94%, 42%)",
        "color-primary-50": "hsl(212, 94%, 83%)",
        "color-primary-500": "hsl(212, 94%, 36%)",
        "color-primary-550": "hsl(212, 94%, 35%)",
        "color-primary-60": "hsl(212, 94%, 78%)",
        "color-primary-600": "hsl(212, 94%, 31%)",
        "color-primary-650": "hsl(212, 94%, 27%)",
        "color-primary-70": "hsl(212, 94%, 76%)",
        "color-primary-700": "hsl(212, 94%, 23%)",
        "color-primary-750": "hsl(212, 94%, 17%)",
        "color-primary-80": "hsl(212, 94%, 72%)",
        "color-primary-800": "hsl(212, 94%, 12%)",
        "color-primary-850": "hsl(212, 94%, 8%)",
        "color-primary-90": "hsl(212, 94%, 68%)",
        "color-primary-900": "hsl(212, 94%, 3%)",
        "color-secondary": "hsl(329,60%,30%)",
        "color-secondary-00": "hsl(329,60%,100%)",
        "color-secondary-10": "hsl(329,60%,98%)",
        "color-secondary-100": "hsl(329,60%,62%)",
        "color-secondary-1000": "hsl(329,60%,0%)",
        "color-secondary-20": "hsl(329,60%,97%)",
        "color-secondary-200": "hsl(329,60%,57%)",
        "color-secondary-30": "hsl(329,60%,92%)",
        "color-secondary-300": "hsl(329,60%,55%)",
        "color-secondary-40": "hsl(329,60%,88%)",
        "color-secondary-400": "hsl(329,60%,52%)",
        "color-secondary-450": "hsl(329,60%,40%)",
        "color-secondary-50": "hsl(329,60%,84%)",
        "color-secondary-500": "hsl(329,60%,37%)",
        "color-secondary-550": "hsl(329,60%,32%)",
        "color-secondary-60": "hsl(329,60%,78%)",
        "color-secondary-600": "hsl(329,60%,30%)",
        "color-secondary-650": "hsl(329,60%,27%)",
        "color-secondary-70": "hsl(329,60%,76%)",
        "color-secondary-700": "hsl(329,60%,22%)",
        "color-secondary-750": "hsl(329,60%,16%)",
        "color-secondary-80": "hsl(329,60%,72%)",
        "color-secondary-800": "hsl(329,60%,11%)",
        "color-secondary-850": "hsl(329,60%,9%)",
        "color-secondary-90": "hsl(329,60%,68%)",
        "color-secondary-900": "hsl(329,60%,4%)",
        "color-status-alert": "hsl(0, 100%, 36%)",
        "color-status-background-alert": "hsl(0, 100%, 98%)",
        "color-status-background-info": "hsl(212, 94%, 97%)",
        "color-status-background-neutral": "hsl(219, 12%, 98%)",
        "color-status-background-success": "hsl(123, 46%, 98%)",
        "color-status-background-warning": "hsl(43, 89%, 98%)",
        "color-status-border-alert": "hsl(0, 100%, 46%)",
        "color-status-border-info": "hsl(212, 94%, 42%)",
        "color-status-border-neutral": "hsl(219, 12%, 48%)",
        "color-status-border-success": "hsl(123, 46%, 48%)",
        "color-status-border-warning": "hsl(43, 89%, 52%)",
        "color-status-icon-alert": "hsl(0, 100%, 36%)",
        "color-status-icon-info": "hsl(212, 94%, 31%)",
        "color-status-icon-neutral": "hsl(219, 12%, 30%)",
        "color-status-icon-success": "hsl(123, 46%, 30%)",
        "color-status-icon-warning": "hsl(43, 89%, 31%)",
        "color-status-info": "hsl(212, 94%, 36%)",
        "color-status-neutral": "hsl(219, 12%, 36%)",
        "color-status-success": "hsl(123, 46%, 36%)",
        "color-status-text-alert": "hsl(0, 100%, 36%)",
        "color-status-text-info": "hsl(212, 94%, 31%)",
        "color-status-text-neutral": "hsl(219, 12%, 30%)",
        "color-status-text-success": "hsl(123, 46%, 30%)",
        "color-status-text-warning": "hsl(43, 89%, 27%)",
        "color-status-warning": "hsl(43, 89%, 39%)",
        "color-success-00": "hsl(123, 0%, 100%)",
        "color-success-10": "hsl(123, 46%, 98%)",
        "color-success-100": "hsl(123, 46%, 63%)",
        "color-success-1000": "hsl(123, 0%, 0%)",
        "color-success-20": "hsl(123, 46%, 95%)",
        "color-success-200": "hsl(123, 46%, 58%)",
        "color-success-30": "hsl(123, 46%, 90%)",
        "color-success-300": "hsl(123, 46%, 55%)",
        "color-success-40": "hsl(123, 46%, 87%)",
        "color-success-400": "hsl(123, 46%, 48%)",
        "color-success-450": "hsl(123, 46%, 43%)",
        "color-success-50": "hsl(123, 46%, 82%)",
        "color-success-500": "hsl(123, 46%, 36%)",
        "color-success-550": "hsl(123, 46%, 34%)",
        "color-success-60": "hsl(123, 46%, 78%)",
        "color-success-600": "hsl(123, 46%, 30%)",
        "color-success-650": "hsl(123, 46%, 25%)",
        "color-success-70": "hsl(123, 46%, 75%)",
        "color-success-700": "hsl(123, 46%, 22%)",
        "color-success-750": "hsl(123, 46%, 17%)",
        "color-success-80": "hsl(123, 46%, 70%)",
        "color-success-800": "hsl(123, 46%, 12%)",
        "color-success-850": "hsl(123, 46%, 8%)",
        "color-success-90": "hsl(123, 46%, 66%)",
        "color-success-900": "hsl(123, 46%, 3%)",
        "color-syntax-text-01": "#1B1D22",
        "color-syntax-text-02": "#6C7689",
        "color-syntax-text-03": "#AD6531",
        "color-syntax-text-04": "#8F4238",
        "color-syntax-text-05": "#6B4896",
        "color-syntax-text-06": "#3578C5",
        "color-syntax-text-07": "#224C7C",
        "color-syntax-text-08": "#3C8275",
        "color-syntax-text-09": "#65802A",
        "color-syntax-text-attribute-name": "#224C7C",
        "color-syntax-text-attribute-value": "#8F4238",
        "color-syntax-text-boolean": "#6B4896",
        "color-syntax-text-character-constant": "#3C8275",
        "color-syntax-text-class-name": "#3C8275",
        "color-syntax-text-comment": "#65802A",
        "color-syntax-text-control": "#6B4896",
        "color-syntax-text-data": "#AD6531",
        "color-syntax-text-declaration": "#3578C5",
        "color-syntax-text-default": "#1B1D22",
        "color-syntax-text-function": "#6B4896",
        "color-syntax-text-identifier": "#1B1D22",
        "color-syntax-text-keyword": "#3578C5",
        "color-syntax-text-namespace": "#3C8275",
        "color-syntax-text-normal": "#1B1D22",
        "color-syntax-text-numeric-constant": "#3C8275",
        "color-syntax-text-operator": "#224C7C",
        "color-syntax-text-proc-name": "#224C7C",
        "color-syntax-text-property": "#3578C5",
        "color-syntax-text-punctuation": "#6C7689",
        "color-syntax-text-punctuation-brackets": "#6C7689",
        "color-syntax-text-section": "#224C7C",
        "color-syntax-text-separator": "#1B1D22",
        "color-syntax-text-source": "#3578C5",
        "color-syntax-text-storage-type": "#3578C5",
        "color-syntax-text-string": "#8F4238",
        "color-syntax-text-tag": "#3578C5",
        "color-syntax-text-variable": "#224C7C",
        "color-tag-background-1": "hsl(212, 94%, 88%)",
        "color-tag-background-2": "hsl(329,60%,88%)",
        "color-tag-background-3": "hsl(219, 12%, 88%)",
        "color-tag-border-1": "hsl(212, 94%, 42%)",
        "color-tag-border-2": "hsl(329,60%,40%)",
        "color-tag-border-3": "hsl(219, 12%, 42%)",
        "color-text-neutral": "hsl(219, 12%, 12%)",
        "color-text-neutral-inverse": "hsl(219, 0%, 100%)",
        "color-text-primary": "hsl(212, 94%, 42%)",
        "color-text-primary-inverse": "hsl(212, 0%, 100%)",
        "color-text-secondary": "hsl(329,60%,30%)",
        "color-thumbnail-fill-1": "hsl(212, 94%, 94%)",
        "color-thumbnail-fill-2": "hsl(212, 94%, 83%)",
        "color-thumbnail-fill-3": "hsl(212, 94%, 62%)",
        "color-thumbnail-fill-4": "hsl(212, 94%, 42%)",
        "color-warning-00": "hsl(43, 0%, 100%)",
        "color-warning-10": "hsl(43, 89%, 98%)",
        "color-warning-100": "hsl(43, 89%, 64%)",
        "color-warning-1000": "hsl(43, 0%, 0%)",
        "color-warning-20": "hsl(43, 89%, 95%)",
        "color-warning-200": "hsl(43, 89%, 60%)",
        "color-warning-30": "hsl(43, 89%, 92%)",
        "color-warning-300": "hsl(43, 89%, 56%)",
        "color-warning-40": "hsl(43, 89%, 88%)",
        "color-warning-400": "hsl(43, 89%, 52%)",
        "color-warning-450": "hsl(43, 89%, 44%)",
        "color-warning-50": "hsl(43, 89%, 84%)",
        "color-warning-500": "hsl(43, 89%, 39%)",
        "color-warning-550": "hsl(43, 89%, 35%)",
        "color-warning-60": "hsl(43, 89%, 79%)",
        "color-warning-600": "hsl(43, 89%, 31%)",
        "color-warning-650": "hsl(43, 89%, 27%)",
        "color-warning-70": "hsl(43, 89%, 76%)",
        "color-warning-700": "hsl(43, 89%, 24%)",
        "color-warning-750": "hsl(43, 89%, 17%)",
        "color-warning-80": "hsl(43, 89%, 72%)",
        "color-warning-800": "hsl(43, 89%, 12%)",
        "color-warning-850": "hsl(43, 89%, 8%)",
        "color-warning-90": "hsl(43, 89%, 68%)",
        "color-warning-900": "hsl(43, 89%, 3%)",
        "color-zero-state-base-fill-1": "hsl(219, 0%, 100%)",
        "color-zero-state-base-fill-2": "hsl(219, 12%, 79%)",
        "color-zero-state-base-fill-3": "hsl(219, 12%, 84%)",
        "color-zero-state-modifier-fill-1": "hsl(219, 12%, 96%)",
        "color-zero-state-modifier-fill-2": "hsl(212, 94%, 42%)",
        "color-zero-state-modifier-fill-3": "hsl(212, 94%, 78%)",
        "color-zero-state-modifier-fill-4": "hsl(219, 12%, 92%)",
        "color-zero-state-modifier-fill-5": "hsl(219, 12%, 64%)",
        "duration-100": "100ms",
        "duration-1000": "1s",
        "duration-200": "200ms",
        "duration-250": "250ms",
        "duration-300": "300ms",
        "duration-400": "400ms",
        "duration-450": "450ms",
        "duration-500": "500ms",
        "duration-700": "700ms",
        "ease-in": "cubic-bezier(0, 0.5, 0.2, 1)",
        "ease-in-out": "cubic-bezier(0.5, 0, 0.2, 1)",
        "ease-out": "cubic-bezier(0.5, 0, 0.8, 1)",
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AnovaUI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "font-family-secondary": "'Anova', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "font-size-base-text": "16px",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "22.4px",
        "font-size-line-height-body-text-m": "19.6px",
        "font-size-line-height-body-text-s": "16.8px",
        "font-size-line-height-body-text-xl": "25.2px",
        "font-size-line-height-body-text-xs": "15.4px",
        "font-size-line-height-body-text-xxl": "28px",
        "font-size-line-height-body-text-xxs": "14px",
        "font-size-line-height-body-text-xxxl": "30.8px",
        "font-size-line-height-body-text-xxxs": "12.6px",
        "font-size-line-height-body-text-xxxxl": "35px",
        "font-size-line-height-display-text-1": "102.2px",
        "font-size-line-height-display-text-2": "81px",
        "font-size-line-height-display-text-3": "56px",
        "font-size-line-height-heading-text-l": "22.4px",
        "font-size-line-height-heading-text-m": "19.6px",
        "font-size-line-height-heading-text-s": "16.8px",
        "font-size-line-height-heading-text-xl": "25.2px",
        "font-size-line-height-heading-text-xxl": "28px",
        "font-size-line-height-heading-text-xxxl": "30.8px",
        "font-size-line-height-heading-text-xxxxl": "39.2px",
        "font-size-line-height-heading-text-xxxxxl": "81px",
        "font-size-ratio": "1.125",
        "font-size-ratio-major-second": "1.125",
        "font-size-ratio-major-third": "1.25",
        "font-size-ratio-minor-third": "1.2",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "2px",
        "font-space-letter-spacing-m": "1px",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "-1px",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "font-space-word": "normal",
        "font-space-word-l": "2px",
        "font-space-word-m": "normal",
        "font-space-word-s": "1px",
        "font-style-expression": "normal",
        "font-style-expression-italic": "italic",
        "font-style-expression-normal": "normal",
        "font-style-expression-oblique": "oblique",
        "font-style-overflow-wrap": "anywhere",
        "font-style-overflow-wrap-anywhere": "anywhere",
        "font-style-overflow-wrap-break-word": "break-word",
        "font-style-overflow-wrap-normal": "normal",
        "font-style-text-transform": "none",
        "font-style-text-transform-capitalize": "capitalize",
        "font-style-text-transform-lowercase": "lowercase",
        "font-style-text-transform-none": "none",
        "font-style-text-transform-uppercase": "uppercase",
        "font-style-weight-300": "300",
        "font-style-weight-400": "400",
        "font-style-weight-500": "500",
        "font-style-weight-600": "600",
        "font-style-weight-700": "700",
        "font-style-word-break": "break-all",
        "font-style-word-break-break-all": "break-all",
        "font-style-word-break-break-word": "break-word",
        "font-style-word-break-keep-all": "keep-all",
        "font-style-word-break-normal": "normal",
        "shadow-depth-l": "0 8px 12px rgba(0, 0, 0, 0.04), 0 16px 24px rgba(0, 0, 0, 0.08)",
        "shadow-depth-m": "0 2px 4px rgba(0, 0, 0, 0.04), 0 8px 16px rgba(0, 0, 0, 0.08)",
        "shadow-depth-s": "0 2px 2px rgba(0, 0, 0, 0.04), 0 4px 8px rgba(0, 0, 0, 0.08)",
        "shadow-depth-xl": "0 16px 24px rgba(0, 0, 0, 0.04), 0 32px 48px rgba(0, 0, 0, 0.08)",
        "shadow-depth-xs": "0 1px 2px rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.08)",
        "size-action-border-width-focus": "2px",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-border-width-l": "3px",
        "size-border-width-m": "2px",
        "size-border-width-null": "0",
        "size-border-width-s": "1px",
        "size-container-l": "400px",
        "size-container-m": "320px",
        "size-container-null": "0",
        "size-container-s": "240px",
        "size-container-xl": "640px",
        "size-container-xs": "192px",
        "size-container-xxl": "960px",
        "size-container-xxs": "96px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "size-outline-width-l": "3px",
        "size-outline-width-m": "2px",
        "size-outline-width-s": "1px",
        "size-outline-width-xl": "4px",
        "size-zero-state-border-width": "0",
        "space-base-l": "1.4375rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem",
        "style-action-border-focus": "solid"
    }
};

const LowDensityChineseVariantsLocalesTokens = {
    "name": "low-density-chinese-variants-locales",
    "selectors": ["[data-sas-theme='low-density']:lang(zh)", "[data-sas-theme='low-density']:lang(zh-cn)", "[data-sas-theme='low-density']:lang(zh-sg)", "[data-sas-theme='low-density']:lang(zh-hans)", "[data-sas-theme='low-density']:lang(zh-cn-pseudo)", "[data-sas-theme='low-density']:lang(zh-hk)", "[data-sas-theme='low-density']:lang(zh-tw)", "[data-sas-theme='low-density']:lang(zh-hant)"],
    "tokens": {
        "font-size-body-text-l": "1.25rem",
        "font-size-body-text-m": "1.125rem",
        "font-size-body-text-s": "1rem",
        "font-size-body-text-xl": "1.4375rem",
        "font-size-body-text-xs": "0.875rem",
        "font-size-body-text-xxl": "1.625rem",
        "font-size-body-text-xxs": "0.75rem",
        "font-size-body-text-xxxl": "1.8125rem",
        "font-size-body-text-xxxs": "0.6875rem",
        "font-size-body-text-xxxxl": "2rem",
        "font-size-display-text-1": "5.25rem",
        "font-size-display-text-2": "4.625rem",
        "font-size-display-text-3": "3.25rem",
        "font-size-heading-text-l": "1.25rem",
        "font-size-heading-text-m": "1.125rem",
        "font-size-heading-text-s": "1rem",
        "font-size-heading-text-xl": "1.4375rem",
        "font-size-heading-text-xxl": "1.625rem",
        "font-size-heading-text-xxxl": "1.8125rem",
        "font-size-heading-text-xxxxl": "2.25rem",
        "font-size-heading-text-xxxxxl": "3.625rem",
        "font-size-heading-text-xxxxxxl": "4.625rem",
        "font-size-line-height-body-text-l": "32px",
        "font-size-line-height-body-text-m": "28.8px",
        "font-size-line-height-body-text-s": "25.6px",
        "font-size-line-height-body-text-xl": "36.8px",
        "font-size-line-height-body-text-xs": "22.4px",
        "font-size-line-height-body-text-xxl": "41.6px",
        "font-size-line-height-body-text-xxs": "19.2px",
        "font-size-line-height-body-text-xxxl": "46.4px",
        "font-size-line-height-body-text-xxxs": "17.6px",
        "font-size-line-height-body-text-xxxxl": "51.2px",
        "font-size-line-height-display-text-1": "134.4px",
        "font-size-line-height-display-text-2": "118.4px",
        "font-size-line-height-display-text-3": "83.2px",
        "font-size-line-height-heading-text-l": "32px",
        "font-size-line-height-heading-text-m": "28.8px",
        "font-size-line-height-heading-text-s": "25.6px",
        "font-size-line-height-heading-text-xl": "36.8px",
        "font-size-line-height-heading-text-xxl": "41.6px",
        "font-size-line-height-heading-text-xxxl": "46.4px",
        "font-size-line-height-heading-text-xxxxl": "57.6px",
        "font-size-line-height-heading-text-xxxxxl": "118.4px",
        "font-space-line-height": "1.6",
        "font-space-line-height-l": "1.8",
        "font-space-line-height-m": "1.7",
        "font-space-line-height-s": "1.6",
        "font-space-line-height-xl": "1.9",
        "font-space-line-height-xxl": "2.0",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "36px",
        "size-border-radius-m": "24px",
        "size-border-radius-s": "12px",
        "size-border-radius-xs": "6px",
        "size-border-radius-xxs": "3px",
        "size-icon-l": "1.25rem",
        "size-icon-m": "1.125rem",
        "size-icon-s": "1rem",
        "size-icon-xl": "1.4375rem",
        "size-icon-xs": "1rem",
        "size-icon-xxl": "1.625rem",
        "size-icon-xxs": "1rem",
        "size-icon-xxxl": "1.8125rem",
        "size-icon-xxxs": "1rem",
        "size-icon-xxxxl": "2rem",
        "space-base-l": "1.875rem",
        "space-base-m": "1.25rem",
        "space-base-null": "0",
        "space-base-s": "0.625rem",
        "space-base-size": "1rem",
        "space-base-xl": "2.5rem",
        "space-base-xs": "0.3125rem",
        "space-base-xxl": "3.125rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "3.75rem",
        "space-base-xxxxl": "4.375rem",
        "space-base-xxxxxl": "5rem"
    }
};

const LowDensityEuroSlavicLocalesTokens = {
    "name": "low-density-euro-slavic-locales",
    "selectors": ["[data-sas-theme='low-density']:lang(en)"],
    "tokens": {
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.75rem",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125re",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "3.25rem",
        "font-size-heading-text-xxxxxxl": "4.125re",
        "font-size-line-height-body-text-l": "19.6px",
        "font-size-line-height-body-text-m": "16.8px",
        "font-size-line-height-body-text-s": "15.4px",
        "font-size-line-height-body-text-xl": "21px",
        "font-size-line-height-body-text-xs": "12.6px",
        "font-size-line-height-body-text-xxl": "23.8px",
        "font-size-line-height-body-text-xxs": "11.2px",
        "font-size-line-height-body-text-xxxl": "26.6px",
        "font-size-line-height-body-text-xxxs": "9.8px",
        "font-size-line-height-body-text-xxxxl": "30.8px",
        "font-size-line-height-display-text-1": "86.8px",
        "font-size-line-height-display-text-2": "68.6px",
        "font-size-line-height-display-text-3": "49px",
        "font-size-line-height-heading-text-l": "19.6px",
        "font-size-line-height-heading-text-m": "16.8px",
        "font-size-line-height-heading-text-s": "15.4px",
        "font-size-line-height-heading-text-xl": "21px",
        "font-size-line-height-heading-text-xxl": "23.8px",
        "font-size-line-height-heading-text-xxxl": "26.6px",
        "font-size-line-height-heading-text-xxxxl": "33.6px",
        "font-size-line-height-heading-text-xxxxxl": "68.6px",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "36px",
        "size-border-radius-m": "24px",
        "size-border-radius-s": "12px",
        "size-border-radius-xs": "6px",
        "size-border-radius-xxs": "3px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.8125re",
        "space-base-l": "1.625rem",
        "space-base-m": "1.125rem",
        "space-base-null": "0",
        "space-base-s": "0.5625rem",
        "space-base-size": "1rem",
        "space-base-xl": "2.25rem",
        "space-base-xs": "0.3125rem",
        "space-base-xxl": "2.875rem",
        "space-base-xxs": "0.1875remm",
        "space-base-xxxl": "3.25rem",
        "space-base-xxxxl": "4.125rem",
        "space-base-xxxxxl": "4.625rem"
    }
};

const LowDensityMenaAsianLocalesTokens = {
    "name": "low-density-mena-asian-locales",
    "selectors": ["[data-sas-theme='low-density']:lang(ar)", "[data-sas-theme='low-density']:lang(ar-xx)", "[data-sas-theme='low-density']:lang(he)", "[data-sas-theme='low-density']:lang(jp)", "[data-sas-theme='low-density']:lang(ko)", "[data-sas-theme='low-density']:lang(th)", "[data-sas-theme='low-density']:lang(vi)", "[data-sas-theme='low-density']:lang(vi-VN)"],
    "tokens": {
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.8125rem",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125r",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "3.25rem",
        "font-size-heading-text-xxxxxxl": "4.125rem",
        "font-size-line-height-body-text-l": "28.8px",
        "font-size-line-height-body-text-m": "25.6px",
        "font-size-line-height-body-text-s": "22.4px",
        "font-size-line-height-body-text-xl": "32px",
        "font-size-line-height-body-text-xs": "20.8px",
        "font-size-line-height-body-text-xxl": "36.8px",
        "font-size-line-height-body-text-xxs": "17.8px",
        "font-size-line-height-body-text-xxxl": "41.6px",
        "font-size-line-height-body-text-xxxs": "16px",
        "font-size-line-height-body-text-xxxxl": "46.4px",
        "font-size-line-height-display-text-1": "132.8px",
        "font-size-line-height-display-text-2": "105.6px",
        "font-size-line-height-display-text-3": "73.6px",
        "font-size-line-height-heading-text-l": "28.8px",
        "font-size-line-height-heading-text-m": "25.6px",
        "font-size-line-height-heading-text-s": "22.4px",
        "font-size-line-height-heading-text-xl": "32px",
        "font-size-line-height-heading-text-xxl": "36.8px",
        "font-size-line-height-heading-text-xxxl": "41.6px",
        "font-size-line-height-heading-text-xxxxl": "51.2px",
        "font-size-line-height-heading-text-xxxxxl": "105.6px",
        "font-space-line-height": "1.6",
        "font-space-line-height-l": "1.8",
        "font-space-line-height-m": "1.7",
        "font-space-line-height-s": "1.6",
        "font-space-line-height-xl": "1.9",
        "font-space-line-height-xxl": "2.0",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "36px",
        "size-border-radius-m": "24px",
        "size-border-radius-s": "12px",
        "size-border-radius-xs": "6px",
        "size-border-radius-xxs": "3px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.875rem",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.875rem",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.875rem",
        "size-icon-xxxxl": "1.8125r",
        "space-base-l": "1.875rem",
        "space-base-m": "1.25rem",
        "space-base-null": "0",
        "space-base-s": "0.625rem",
        "space-base-size": "1rem",
        "space-base-xl": "2.5rem",
        "space-base-xs": "0.3125rem",
        "space-base-xxl": "3.125rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "3.75rem",
        "space-base-xxxxl": "4.375rem",
        "space-base-xxxxxl": "5rem"
    }
};

const LowDensityTokens = {
    "name": "low-density",
    "selectors": ["[data-sas-theme='low-density']"],
    "tokens": {
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.75rem",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125re",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "3.25rem",
        "font-size-heading-text-xxxxxxl": "4.125re",
        "font-size-line-height-body-text-l": "19.6px",
        "font-size-line-height-body-text-m": "16.8px",
        "font-size-line-height-body-text-s": "15.4px",
        "font-size-line-height-body-text-xl": "21px",
        "font-size-line-height-body-text-xs": "12.6px",
        "font-size-line-height-body-text-xxl": "23.8px",
        "font-size-line-height-body-text-xxs": "11.2px",
        "font-size-line-height-body-text-xxxl": "26.6px",
        "font-size-line-height-body-text-xxxs": "9.8px",
        "font-size-line-height-body-text-xxxxl": "30.8px",
        "font-size-line-height-display-text-1": "86.8px",
        "font-size-line-height-display-text-2": "68.6px",
        "font-size-line-height-display-text-3": "49px",
        "font-size-line-height-heading-text-l": "19.6px",
        "font-size-line-height-heading-text-m": "16.8px",
        "font-size-line-height-heading-text-s": "15.4px",
        "font-size-line-height-heading-text-xl": "21px",
        "font-size-line-height-heading-text-xxl": "23.8px",
        "font-size-line-height-heading-text-xxxl": "26.6px",
        "font-size-line-height-heading-text-xxxxl": "33.6px",
        "font-size-line-height-heading-text-xxxxxl": "68.6px",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "36px",
        "size-border-radius-m": "24px",
        "size-border-radius-s": "12px",
        "size-border-radius-xs": "6px",
        "size-border-radius-xxs": "3px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.8125re",
        "space-base-l": "1.625rem",
        "space-base-m": "1.125rem",
        "space-base-null": "0",
        "space-base-s": "0.5625rem",
        "space-base-size": "1rem",
        "space-base-xl": "2.25rem",
        "space-base-xs": "0.3125rem",
        "space-base-xxl": "2.875rem",
        "space-base-xxs": "0.1875remm",
        "space-base-xxxl": "3.25rem",
        "space-base-xxxxl": "4.125rem",
        "space-base-xxxxxl": "4.625rem"
    }
};

const MediumDensityChineseVariantsLocalesTokens = {
    "name": "medium-density-chinese-variants-locales",
    "selectors": ["[data-sas-theme='low-density']:lang(zh)", "[data-sas-theme='low-density']:lang(zh-cn)", "[data-sas-theme='low-density']:lang(zh-sg)", "[data-sas-theme='low-density']:lang(zh-hans)", "[data-sas-theme='low-density']:lang(zh-cn-pseudo)", "[data-sas-theme='low-density']:lang(zh-hk)", "[data-sas-theme='low-density']:lang(zh-tw)", "[data-sas-theme='low-density']:lang(zh-hant)"],
    "tokens": {
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.8125rem",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125rem",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "3.25rem",
        "font-size-heading-text-xxxxxxl": "4.125rem",
        "font-size-line-height-body-text-l": "27px",
        "font-size-line-height-body-text-m": "24px",
        "font-size-line-height-body-text-s": "21px",
        "font-size-line-height-body-text-xl": "30px",
        "font-size-line-height-body-text-xs": "19.5px",
        "font-size-line-height-body-text-xxl": "34.5px",
        "font-size-line-height-body-text-xxs": "16.5px",
        "font-size-line-height-body-text-xxxl": "39px",
        "font-size-line-height-body-text-xxxs": "15px",
        "font-size-line-height-body-text-xxxxl": "48px",
        "font-size-line-height-display-text-1": "124.5px",
        "font-size-line-height-display-text-2": "99px",
        "font-size-line-height-display-text-3": "69px",
        "font-size-line-height-heading-text-l": "27px",
        "font-size-line-height-heading-text-m": "24px",
        "font-size-line-height-heading-text-s": "21px",
        "font-size-line-height-heading-text-xl": "30px",
        "font-size-line-height-heading-text-xxl": "34.5px",
        "font-size-line-height-heading-text-xxxl": "39px",
        "font-size-line-height-heading-text-xxxxl": "48px",
        "font-size-line-height-heading-text-xxxxxl": "99px",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.875rem",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.875rem",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.875rem",
        "size-icon-xxxxl": "1.8125rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "3rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4rem"
    }
};

const MediumDensityEuroSlavicLocalesTokens = {
    "name": "medium-density-euro-slavic-locales",
    "selectors": ["[data-sas-theme='medium-density']:lang(en)"],
    "tokens": {
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "22.4px",
        "font-size-line-height-body-text-m": "19.6px",
        "font-size-line-height-body-text-s": "16.8px",
        "font-size-line-height-body-text-xl": "25.2px",
        "font-size-line-height-body-text-xs": "15.4px",
        "font-size-line-height-body-text-xxl": "28px",
        "font-size-line-height-body-text-xxs": "14px",
        "font-size-line-height-body-text-xxxl": "30.8px",
        "font-size-line-height-body-text-xxxs": "12.6px",
        "font-size-line-height-body-text-xxxxl": "35px",
        "font-size-line-height-display-text-1": "102.2px",
        "font-size-line-height-display-text-2": "81px",
        "font-size-line-height-display-text-3": "56px",
        "font-size-line-height-heading-text-l": "22.4px",
        "font-size-line-height-heading-text-m": "19.6px",
        "font-size-line-height-heading-text-s": "16.8px",
        "font-size-line-height-heading-text-xl": "25.2px",
        "font-size-line-height-heading-text-xxl": "28px",
        "font-size-line-height-heading-text-xxxl": "30.8px",
        "font-size-line-height-heading-text-xxxxl": "39.2px",
        "font-size-line-height-heading-text-xxxxxl": "81px",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.4375rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem"
    }
};

const MediumDensityMenaAsianLocalesTokens = {
    "name": "medium-density-mena-asian-locales",
    "selectors": ["[data-sas-theme='medium-density']:lang(ar)", "[data-sas-theme='medium-density']:lang(ar-xx)", "[data-sas-theme='medium-density']:lang(he)", "[data-sas-theme='medium-density']:lang(jp)", "[data-sas-theme='medium-density']:lang(ko)", "[data-sas-theme='medium-density']:lang(th)", "[data-sas-theme='medium-density']:lang(vi)", "[data-sas-theme='medium-density']:lang(vi-VN)"],
    "tokens": {
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "24px",
        "font-size-line-height-body-text-m": "21px",
        "font-size-line-height-body-text-s": "18px",
        "font-size-line-height-body-text-xl": "27px",
        "font-size-line-height-body-text-xs": "16.5px",
        "font-size-line-height-body-text-xxl": "30px",
        "font-size-line-height-body-text-xxs": "15px",
        "font-size-line-height-body-text-xxxl": "33px",
        "font-size-line-height-body-text-xxxs": "13.5px",
        "font-size-line-height-body-text-xxxxl": "37.5px",
        "font-size-line-height-display-text-1": "109.5px",
        "font-size-line-height-display-text-2": "87px",
        "font-size-line-height-display-text-3": "60px",
        "font-size-line-height-heading-text-l": "24px",
        "font-size-line-height-heading-text-m": "21px",
        "font-size-line-height-heading-text-s": "18px",
        "font-size-line-height-heading-text-xl": "27px",
        "font-size-line-height-heading-text-xxl": "30px",
        "font-size-line-height-heading-text-xxxl": "33px",
        "font-size-line-height-heading-text-xxxxl": "42px",
        "font-size-line-height-heading-text-xxxxxl": "87px",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "3rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4rem"
    }
};

const MediumDensityTokens = {
    "name": "medium-density",
    "selectors": ["[data-sas-theme='medium-density']"],
    "tokens": {
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "22.4px",
        "font-size-line-height-body-text-m": "19.6px",
        "font-size-line-height-body-text-s": "16.8px",
        "font-size-line-height-body-text-xl": "25.2px",
        "font-size-line-height-body-text-xs": "15.4px",
        "font-size-line-height-body-text-xxl": "28px",
        "font-size-line-height-body-text-xxs": "14px",
        "font-size-line-height-body-text-xxxl": "30.8px",
        "font-size-line-height-body-text-xxxs": "12.6px",
        "font-size-line-height-body-text-xxxxl": "35px",
        "font-size-line-height-display-text-1": "102.2px",
        "font-size-line-height-display-text-2": "81px",
        "font-size-line-height-display-text-3": "56px",
        "font-size-line-height-heading-text-l": "22.4px",
        "font-size-line-height-heading-text-m": "19.6px",
        "font-size-line-height-heading-text-s": "16.8px",
        "font-size-line-height-heading-text-xl": "25.2px",
        "font-size-line-height-heading-text-xxl": "28px",
        "font-size-line-height-heading-text-xxxl": "30.8px",
        "font-size-line-height-heading-text-xxxxl": "39.2px",
        "font-size-line-height-heading-text-xxxxxl": "81px",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.4375rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem"
    }
};

const TaiwaneseTokens = {
    "name": "taiwanese",
    "selectors": [":lang(zh-tw)", ":lang(zh-hant)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AnovaUI', '微軟正黑體', 'Microsoft JhengHei', '黑體-繁', 'Heiti TC', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'Anova', '微軟正黑體', 'Microsoft JhengHei', '黑體-繁', 'Heiti TC', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.8125rem",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125rem",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "3.25rem",
        "font-size-heading-text-xxxxxxl": "4.125rem",
        "font-size-line-height-body-text-l": "27px",
        "font-size-line-height-body-text-m": "24px",
        "font-size-line-height-body-text-s": "21px",
        "font-size-line-height-body-text-xl": "30px",
        "font-size-line-height-body-text-xs": "19.5px",
        "font-size-line-height-body-text-xxl": "34.5px",
        "font-size-line-height-body-text-xxs": "16.5px",
        "font-size-line-height-body-text-xxxl": "39px",
        "font-size-line-height-body-text-xxxs": "15px",
        "font-size-line-height-body-text-xxxxl": "48px",
        "font-size-line-height-display-text-1": "124.5px",
        "font-size-line-height-display-text-2": "99px",
        "font-size-line-height-display-text-3": "69px",
        "font-size-line-height-heading-text-l": "27px",
        "font-size-line-height-heading-text-m": "24px",
        "font-size-line-height-heading-text-s": "21px",
        "font-size-line-height-heading-text-xl": "30px",
        "font-size-line-height-heading-text-xxl": "34.5px",
        "font-size-line-height-heading-text-xxxl": "39px",
        "font-size-line-height-heading-text-xxxxl": "48px",
        "font-size-line-height-heading-text-xxxxxl": "99px",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-expression-italic": "normal",
        "font-style-text-transform-uppercase": "initial",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.875rem",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.875rem",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.875rem",
        "size-icon-xxxxl": "1.8125rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "3rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4rem"
    }
};

const ThaiTokens = {
    "name": "thai",
    "selectors": [":lang(th)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AnovaUI', 'Thonburi', 'Leelawadee UI', 'TH Sarabun New', 'Cordia New', Roboto, Noto, 'Noto Sans Thai', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'Anova', 'Thonburi', 'Leelawadee UI', 'TH Sarabun New', 'Cordia New', Roboto, Noto, 'Noto Sans Thai', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.8125rem",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125rem",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "3.25rem",
        "font-size-heading-text-xxxxxxl": "4.125rem",
        "font-size-line-height-body-text-l": "27px",
        "font-size-line-height-body-text-m": "24px",
        "font-size-line-height-body-text-s": "21px",
        "font-size-line-height-body-text-xl": "30px",
        "font-size-line-height-body-text-xs": "19.5px",
        "font-size-line-height-body-text-xxl": "34.5px",
        "font-size-line-height-body-text-xxs": "16.5px",
        "font-size-line-height-body-text-xxxl": "39px",
        "font-size-line-height-body-text-xxxs": "15px",
        "font-size-line-height-body-text-xxxxl": "48px",
        "font-size-line-height-display-text-1": "124.5px",
        "font-size-line-height-display-text-2": "99px",
        "font-size-line-height-display-text-3": "69px",
        "font-size-line-height-heading-text-l": "27px",
        "font-size-line-height-heading-text-m": "24px",
        "font-size-line-height-heading-text-s": "21px",
        "font-size-line-height-heading-text-xl": "30px",
        "font-size-line-height-heading-text-xxl": "34.5px",
        "font-size-line-height-heading-text-xxxl": "39px",
        "font-size-line-height-heading-text-xxxxl": "48px",
        "font-size-line-height-heading-text-xxxxxl": "99px",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-expression-italic": "normal",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.875rem",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.875rem",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.875rem",
        "size-icon-xxxxl": "1.8125rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "3rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4rem"
    }
};

const VietnameseTokens = {
    "name": "vietnamese",
    "selectors": [":lang(vi)", ":lang(vi-VN)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AnovaUI', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'Anova', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "24px",
        "font-size-line-height-body-text-m": "21px",
        "font-size-line-height-body-text-s": "18px",
        "font-size-line-height-body-text-xl": "27px",
        "font-size-line-height-body-text-xs": "16.5px",
        "font-size-line-height-body-text-xxl": "30px",
        "font-size-line-height-body-text-xxs": "15px",
        "font-size-line-height-body-text-xxxl": "33px",
        "font-size-line-height-body-text-xxxs": "13.5px",
        "font-size-line-height-body-text-xxxxl": "37.5px",
        "font-size-line-height-display-text-1": "109.5px",
        "font-size-line-height-display-text-2": "87px",
        "font-size-line-height-display-text-3": "60px",
        "font-size-line-height-heading-text-l": "24px",
        "font-size-line-height-heading-text-m": "21px",
        "font-size-line-height-heading-text-s": "18px",
        "font-size-line-height-heading-text-xl": "27px",
        "font-size-line-height-heading-text-xxl": "30px",
        "font-size-line-height-heading-text-xxxl": "33px",
        "font-size-line-height-heading-text-xxxxl": "42px",
        "font-size-line-height-heading-text-xxxxxl": "87px",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.5rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "3rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4rem"
    }
};

export { ArabicPseudoTokens, ArabicTokens, ChineseChinaTokens, ChineseHongKongTokens, ChinesePseudoTokens, DarkTokens, EnglishTokens, HebrewTokens, HighContrastTokens, HighDensityChineseVariantsTokens, HighDensityEuroSlavicLocalesTokens, HighDensityMenaAsianLocalesTokens, HighDensityTokens, JapaneseTokens, KoreanTokens, LightTokens, LowDensityChineseVariantsLocalesTokens, LowDensityEuroSlavicLocalesTokens, LowDensityMenaAsianLocalesTokens, LowDensityTokens, MediumDensityChineseVariantsLocalesTokens, MediumDensityEuroSlavicLocalesTokens, MediumDensityMenaAsianLocalesTokens, MediumDensityTokens, TaiwaneseTokens, ThaiTokens, VietnameseTokens };
//# sourceMappingURL=index.js.map
